var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIndicateImg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 532.661,
    height: 419.341,
    viewBox: "0 0 532.661 419.341",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#ebebeb;}.a,.c{opacity:0.6;}.b{fill:#b2c8f9;}.c{fill:#d6d6d6;}.d{fill:#215b2d;}.e{fill:#093a11;}.f{fill:#a7c156;}.g{fill:#7b8e28;}.h{fill:#12441a;}.i{fill:#859b29;}.j{fill:#56a528;}.k{fill:#e7a592;}.l{fill:#c3643b;}.m{fill:#142439;}.n{fill:#243a59;}.o{fill:#335982;}.p{fill:#1a998f;}.q{fill:#60a9a5;}.r{fill:#ededed;}.ak,.s,.z{fill:#fff;}.t{fill:#050505;}.u{fill:#e2876c;}.v{fill:#bb5c4a;}.w{fill:#153303;}.x{fill:#1b877f;}.y{fill:#f1cc5a;}.z{opacity:0.2;}.aa{fill:#e08820;}.ab{fill:#eaa928;}.ac{fill:#cc1950;}.ad{fill:#3d2828;}.ae{fill:#e0956c;}.af{fill:#ac91d0;}.ag{fill:#e5b893;}.ah{fill:#de5177;}.ai{fill:#3149bb;}.aj{fill:#ba6a4a;}.ak{opacity:0.3;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-85.61 -97.85)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M584.637,316.673h0a170.6,170.6,0,0,1-23.276,59.261,172.812,172.812,0,0,1-146.2,80.438H298.641a172.655,172.655,0,0,1-124.979-53.525q-2.089-2.21-4.125-4.49a174.6,174.6,0,0,1-38.166-70.791,170.984,170.984,0,0,1-4.918-26.65q0-.325,0-.65a301.134,301.134,0,0,1-1.355-47.149c1.87-33.221,10.243-62.066,26.447-83.581,18.846-25.038,48.3-40.131,90.45-40.646h5.284c116.125,1.748,112.25,54.7,207.293,77.931,21.745,5.311,48.639,9.077,83.337,10.31a21.731,21.731,0,0,1,2.317.122C589.027,220.438,594.27,266.083,584.637,316.673Z",
    transform: "translate(13.88 11.015)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M337.875,139.013l1.463-7.37-6.923-1.355a17.37,17.37,0,0,0-.921-5.419l5.717-3.834L333,114.775l-5.419,3.672a16.88,16.88,0,0,0-5.609-3.78l1.355-6.937-7.411-1.45-1.355,7.154a16.827,16.827,0,0,0-4.512.867l-3.929-5.69-6.259,4.214,3.672,5.419a16.88,16.88,0,0,0-3.78,5.609l-6.056-1.192-1.463,7.4,6.286,1.233a16.977,16.977,0,0,0,1.355,5.717l-5.419,3.672,4.214,6.259,5.717-3.834a16.747,16.747,0,0,0,5.514,3.2l-1.355,6.977,7.411,1.45,1.477-7.56a16.733,16.733,0,0,0,4.8-1.26l3.672,5.419,6.259-4.214-3.834-5.717a17.047,17.047,0,0,0,2.52-3.834Zm-18.589-2.967a6.91,6.91,0,1,1,1.883-9.592A6.91,6.91,0,0,1,319.286,136.046Z",
    transform: "translate(73.32 2.991)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M131.255,318.194l1.45-7.411-6.937-1.355a16.978,16.978,0,0,0-.908-5.419l5.7-3.834-4.2-6.26-5.419,3.672a16.882,16.882,0,0,0-5.609-3.78l1.355-6.937-7.4-1.45-1.355,7.154a16.732,16.732,0,0,0-4.5.867l-3.834-5.717-6.259,4.214,3.672,5.419a16.881,16.881,0,0,0-3.78,5.609l-6.056-1.192-1.572,7.465,6.273,1.233a16.691,16.691,0,0,0,1.355,5.717l-5.419,3.672,4.214,6.259,5.7-3.834a16.881,16.881,0,0,0,5.447,3.211l-1.355,6.977,7.343,1.423,1.477-7.56a16.851,16.851,0,0,0,4.8-1.26l3.672,5.419,6.259-4.214-3.834-5.717a16.542,16.542,0,0,0,2.506-3.834Zm-18.589-2.967a6.91,6.91,0,1,1,1.883-9.592,6.91,6.91,0,0,1-1.883,9.592Z",
    transform: "translate(0 66.56)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M287.076,115.825l.8-4.065-3.794-.745a8.9,8.9,0,0,0-.5-2.954l3.13-2.1-2.3-3.428-2.994,2.019a9.145,9.145,0,0,0-3.062-2.073l.745-3.794-4.065-.786-.759,3.9a9.254,9.254,0,0,0-2.466.488l-2.1-3.13-3.414,2.3,2.005,2.981a9.1,9.1,0,0,0-2.059,3.076l-3.319-.65-.8,4.065,3.441.677a9,9,0,0,0,.718,3.116l-2.967,2.005,2.29,3.414,3.13-2.1a9.39,9.39,0,0,0,3.008,1.761l-.745,3.807,4.065.8.8-4.146a9.09,9.09,0,0,0,2.628-.691l2.005,2.994,3.428-2.3-2.1-3.116a8.89,8.89,0,0,0,1.355-2.1ZM276.929,114.2a3.766,3.766,0,1,1,1.606-2.407,3.78,3.78,0,0,1-1.606,2.407Z",
    transform: "translate(62.635 0.018)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M484.7,149.341l.8-4.065-3.794-.745a9.279,9.279,0,0,0-.5-2.967l3.116-2.1-2.29-3.414-2.981,2.032a9.172,9.172,0,0,0-3.062-2.059l.745-3.794-4.064-.8-.772,3.916a9.036,9.036,0,0,0-2.452.474l-2.1-3.13-3.428,2.3,2.019,2.994a9.284,9.284,0,0,0-2.073,3.062l-3.306-.65-.8,4.065,3.428.664a9.478,9.478,0,0,0,.732,3.13l-2.994,2.005,2.3,3.414,3.13-2.086a9.213,9.213,0,0,0,3.008,1.748l-.745,3.807,4.064.8.813-4.132a8.885,8.885,0,0,0,2.615-.691l2.019,2.981,3.414-2.29-2.1-3.13a8.947,8.947,0,0,0,1.355-2.1Zm-10.161-1.612a3.78,3.78,0,1,1,1.03-5.243A3.78,3.78,0,0,1,474.542,147.729Z",
    transform: "translate(132.769 11.916)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "c",
    cx: 247.898,
    cy: 16.868,
    rx: 247.898,
    ry: 16.868,
    transform: "translate(106.922 483.455)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M383.15,245.759c3.563,17.152-11.449,24.658-4.674,36.486s4.159,25.011-7.4,28.452-20.255,5.23-18.548,19.727-10.161,28.574-21.2,22.369l-8.644-4.864-2.371-1.355-.542-.312a26.433,26.433,0,0,1-11.449-33.411c2.181-5,5.8-9.091,11.719-10.351,18.562-3.916,4.065-16.922,9.985-28.885,6.774-13.779,20.987-9.972,24.916-20.729C360.443,237.9,379.614,228.607,383.15,245.759Z",
    transform: "translate(78.283 49.209)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M363.813,256.206l-44.792,85.356-2.371-1.355,44.71-85.356a1.361,1.361,0,0,1,2.412,1.26Z",
    transform: "translate(81.986 55.453)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M418.378,294.757c-3.821,18.372-21.773,19.334-20.16,33.871s-6.585,26.338-19.388,24.74-22.125-3.5-26.623,11.462-22.179,23.737-30.444,12.925c-2.046-2.71-4.254-5.609-6.409-8.481l-1.761-2.317-.406-.542a28.316,28.316,0,0,1,3.021-37.692c4.268-4,9.565-6.476,15.92-5.176,19.916,4.064,11.259-14.9,22.138-24.13,12.519-10.649,24.862-.84,33.316-9.728C399.383,277.32,422.186,276.385,418.378,294.757Z",
    transform: "translate(78.701 64.865)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M394.209,298.91l-80.438,64.8L312.01,361.4l80.37-64.762a1.46,1.46,0,1,1,1.829,2.276Z",
    transform: "translate(80.339 70.426)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M191.972,285.4c-2.114,17.4,13.549,23.6,7.723,35.971s-2.019,25.268,9.782,27.666,20.621,3.5,20.147,18.087,12.532,27.612,23.033,20.5l8.2-5.582,2.249-1.545.515-.339a26.433,26.433,0,0,0,8.576-34.264c-2.588-4.8-6.53-8.576-12.546-9.321-18.819-2.344-5.514-16.516-12.383-27.951-7.9-13.156-21.745-8.129-26.569-18.534C213.975,275.642,194.085,268,191.972,285.4Z",
    transform: "translate(37.673 62.993)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M204.546,294.639l51.837,81.291,2.249-1.545-51.8-81.291a1.359,1.359,0,0,0-2.29,1.463Z",
    transform: "translate(42.129 69.061)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M169.969,336.484c5.419,17.992,23.317,17.423,22.938,32.029s8.793,25.742,21.407,23.033,21.759-5.352,27.517,9.172,24.1,21.745,31.433,10.31l5.663-8.983,1.558-2.466.366-.569a28.33,28.33,0,0,0-6.232-37.313c-4.593-3.6-10.08-5.636-16.258-3.807-19.5,5.731-12.465-13.874-24.076-22.179-13.386-9.552-24.862,1.26-34.02-6.883C187.42,317.516,164.618,318.491,169.969,336.484Z",
    transform: "translate(29.652 79.337)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M187.1,338.979l85.627,57.785,1.558-2.466-85.545-57.73a1.458,1.458,0,1,0-1.639,2.412Z",
    transform: "translate(35.786 84.619)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M267.641,157.266c5.609-22.247,6.774-44.358-5.189-40.564s-13.386,41.879-1.585,68.8l1.829,10.121c-8.265-19.767-27.707-38.275-37.394-33.763s4.43,15.635,18.968,23.669c11.056,6.124,16.909,12.668,19.537,16.258l8.617,47.786c-13.169-31.27-43.884-60.454-59.221-53.3s7.032,24.807,30.091,37.557c17.437,9.633,26.7,19.943,30.931,25.742l1.721,9.484,5.094-.149L270.784,212a65.723,65.723,0,0,1,10.947-17.288c10.839-12.6,20.092-27.964,9.484-28.8-9.2-.732-19.2,17.125-22.314,35.782l-3.536-19.659a94.417,94.417,0,0,1,2.276-24.767Z",
    transform: "translate(43.485 6.538)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M457.693,358.17l9.2,12.3s-1.68,5.5-8.495,9.741L447.41,366.069Z",
    transform: "translate(128.387 92.376)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M460.816,373.71s-4.308-.935-5.785.556-5.162,21.678-8.617,26.162,0,6.774,2.154,7.682,32.611-29.563,32.611-29.563-7.533-10.419-11.164-12.438S464.677,371.57,460.816,373.71Z",
    transform: "translate(127.513 95.072)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M417.072,374.04l-1.355,15.3S410.8,392.3,402.9,390.894l1.287-17.884Z",
    transform: "translate(112.592 97.642)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M413.912,385.561s-2.71-3.726-4.864-3.59-19.185,13.237-24.97,14.267-4.715,5.27-3.685,7.452,45.726.935,45.726.935,1.653-14.429.244-18.534S418.411,386.591,413.912,385.561Z",
    transform: "translate(104.316 100.82)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M428.061,252.723l9.294,76.969a258.481,258.481,0,0,1,16.258,25.742C460.28,367.628,478,399.1,478,399.1l-10.744,8.2L408.388,346.33,396.1,246.87Z",
    transform: "translate(110.179 52.88)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M446.72,367.963a11.786,11.786,0,0,0,4.878,5.419l12.478-10.541a18.834,18.834,0,0,0-4.254-5.772Z",
    transform: "translate(128.142 91.985)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M463.347,251.18s-6.774,43.951-28.289,75.736c0,0-3.211,30.931-8.712,47.42-2.412,7.208-7.086,41.364-7.086,41.364l-16.34-.745,5.975-91.873,15.54-71.889Z",
    transform: "translate(112.599 54.41)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M401.977,371.64a13.643,13.643,0,0,0,0,8.481l18.968.528a21.949,21.949,0,0,0,.786-8.278Z",
    transform: "translate(112.024 97.156)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M422.113,150.23S407.467,183.505,400,195.347c0,0-4.43,2.534-24.9,13.549-7.249,3.9-9.877,5.419-9.877,5.419l-.813,12.194s42.7-7.912,53.517-15.716c0,0,7.723-19.794,9.755-39.535Z",
    transform: "translate(98.933 18.587)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M468.9,293.317l1.152-54.966,7.736-82.809-18.941-6.49-1.016-.339-4.254-1.463-15.689,2.3-7.723-.772-3.265.434-1.138.163-14.334,1.91L394.36,288.7Z",
    transform: "translate(109.561 17.53)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M433.049,159.69l-.813,82.606-11.8,20.12-6.815-22.409,15.947-80.316Z",
    transform: "translate(116.396 21.944)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s",
    d: "M433.515,158.949l-5.826,7.33L422.5,155.887l5.406-6.937Z",
    transform: "translate(119.547 18.133)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "t",
    d: "M456.706,121.668c0,13.156-8.129,22.22-21.258,22.22s-22.328-9.755-22.328-22.911,7.79-23.127,20.946-23.127C449.85,97.85,456.706,108.5,456.706,121.668Z",
    transform: "translate(116.219)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "u",
    d: "M443.479,120.25s3.658-4.877,6.368-.854-1.124,15.947-7.777,13.034Z",
    transform: "translate(126.492 7.081)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M443.287,127.636a.556.556,0,0,0,.542-.42,8.685,8.685,0,0,1,4.877-5.176.569.569,0,0,0-.393-1.057,9.7,9.7,0,0,0-5.569,5.934.569.569,0,0,0,.393.691Z",
    transform: "translate(126.724 8.204)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M446.621,125.2a.488.488,0,0,0,.3-.095.555.555,0,0,0,.176-.772,5.217,5.217,0,0,0-2.113-1.707.569.569,0,0,0-.461,1.03,3.9,3.9,0,0,1,1.626,1.355.569.569,0,0,0,.474.19Z",
    transform: "translate(127.265 8.784)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "u",
    d: "M417.2,120.25s-3.658-4.877-6.381-.854,1.124,15.947,7.79,13.034Z",
    transform: "translate(115.089 7.081)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M416.761,127.638a.569.569,0,0,1-.542-.42,8.684,8.684,0,0,0-4.877-5.176.569.569,0,0,1,.406-1.057,9.66,9.66,0,0,1,5.555,5.934.542.542,0,0,1-.379.691Z",
    transform: "translate(115.477 8.203)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M412.578,125.206a.528.528,0,0,1-.312-.095.555.555,0,0,1-.163-.772,5.216,5.216,0,0,1,2.114-1.707.561.561,0,0,1,.447,1.03,3.915,3.915,0,0,0-1.612,1.355A.583.583,0,0,1,412.578,125.206Z",
    transform: "translate(115.825 8.778)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M422.56,136.06v12.519s2.439,5.162,7.208,5.568,10.107-5,10.107-5V136.886Z",
    transform: "translate(119.568 13.559)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "u",
    d: "M422.56,136.06V141.3c3.211,3.563,8.9,4.444,17.315,3.211v-7.628Z",
    transform: "translate(119.568 13.559)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M455.594,125.386c0,.691-.108,1.355-.176,2.086-.176,1.761-.406,3.577-.732,5.419v.176c-1.585,8.739-5.162,17.315-12.857,20.065-17.451,6.232-23.683-8.725-26.176-17.451-.271-.975-.528-2.046-.745-3.2v-.149c-.244-1.355-.447-2.71-.637-4.065-.122-1.043-.244-2.114-.339-3.184-.257-2.615-.42-5.23-.528-7.547a12.3,12.3,0,0,1,7.885-12.085c7.154-2.71,18.02-4.932,28.316.908a12.356,12.356,0,0,1,6.273,10.527C455.865,119.248,455.824,122.2,455.594,125.386Z",
    transform: "translate(116.314 1.716)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "t",
    d: "M453.369,119.865a106.093,106.093,0,0,1-3.455,11.394c-3.848-4.065-15.188,0-15.188,0s-12.722-4.62-15,.962c-1.463-2.71-2.588-8.427-3.333-12.383l-2.615-.677c.095,1.07.217,2.141.339,3.184.19,1.355.393,2.791.637,4.065v.149c.217,1.152.474,2.222.745,3.2,2.493,8.725,8.725,23.683,26.176,17.451,7.7-2.71,11.272-11.327,12.858-20.065v-.176c.325-1.8.555-3.617.732-5.419,0-.7.122-1.355.176-2.086Zm-8.129,18.968A18.061,18.061,0,0,1,431.1,141.84a15.675,15.675,0,0,1-7.8-4.688c.42-2.71,2.71-5.054,11.855-3.794,10.988-2.8,10.459,3.346,9.985,5.46Z",
    transform: "translate(116.453 7.562)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "w",
    d: "M433.58,120.72c0,1.26.65,2.29,1.463,2.29s1.45-1.03,1.45-2.29-.65-2.29-1.45-2.29S433.58,119.46,433.58,120.72Z",
    transform: "translate(123.479 7.303)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "w",
    d: "M421.12,120.72c0,1.26.65,2.29,1.463,2.29s1.45-1.03,1.45-2.29-.65-2.29-1.45-2.29S421.12,119.46,421.12,120.72Z",
    transform: "translate(119.057 7.303)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "t",
    d: "M419.215,114.554s4.579-1.8,8.129-.285l-.352,1.965s-5.189-.434-7.8.623A3.455,3.455,0,0,1,419.215,114.554Z",
    transform: "translate(118.306 5.611)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "t",
    d: "M441.029,114.554s-4.593-1.8-8.129-.285l.352,1.965s5.189-.434,7.8.623a3.442,3.442,0,0,0-.027-2.3Z",
    transform: "translate(123.238 5.611)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "u",
    d: "M429.253,130.335a5.827,5.827,0,0,0,2.073-.176.562.562,0,0,0-.3-1.084,3.319,3.319,0,0,1-2.263-.068.569.569,0,0,1-.2-.542,81.686,81.686,0,0,1,1.355-8.509.567.567,0,0,0-1.111-.23,81.368,81.368,0,0,0-1.355,8.712,1.72,1.72,0,0,0,.637,1.463A2.317,2.317,0,0,0,429.253,130.335Z",
    transform: "translate(121.302 7.605)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s",
    d: "M438.19,129.93c-.461,2.317-1.992,6.571-7.14,6.571s-6.6-3.888-7.1-6.571Z",
    transform: "translate(120.062 11.384)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "t",
    d: "M413.964,125.729h2.547a18.535,18.535,0,0,1,1.355-7.709c1.748-4.674-1.965-6.774,1.043-9.077s10.459-1.355,15.648-1.5,13.549-.095,15.649.379.921,3.848.176,6.476,2.493,5.528,3.048,8.238a12.481,12.481,0,0,1,0,3.2h2.113c.258-3.306.3-6.381.244-8.874a12.356,12.356,0,0,0-6.273-10.527c-10.3-5.839-21.163-3.658-28.316-.908a12.329,12.329,0,0,0-7.885,12.085C413.49,120.025,413.666,122.9,413.964,125.729Z",
    transform: "translate(116.282 1.698)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s",
    d: "M423.949,129.413a6.707,6.707,0,1,1,6.774-6.693A6.774,6.774,0,0,1,423.949,129.413Zm0-12.356a5.663,5.663,0,1,0,5.65,5.663A5.663,5.663,0,0,0,423.949,117.057Z",
    transform: "translate(117.705 6.441)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s",
    d: "M437.487,129.413a6.707,6.707,0,1,1,6.707-6.693A6.775,6.775,0,0,1,437.487,129.413Zm0-12.356a5.663,5.663,0,1,0,4.015,1.683A5.663,5.663,0,0,0,437.487,117.057Z",
    transform: "translate(122.485 6.441)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s",
    d: "M420.2,120.247a.474.474,0,0,1-.366-.149h0a8.265,8.265,0,0,0-7.072-2.046.528.528,0,0,1-.244-1.016,9.145,9.145,0,0,1,8.048,2.317.528.528,0,0,1,0,.745.474.474,0,0,1-.366.149Z",
    transform: "translate(115.887 6.746)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s",
    d: "M440.067,120.3a.515.515,0,0,1-.285-.948c.2-.135,4.945-3.2,8.969-2.534a.521.521,0,0,1-.163,1.03c-3.631-.6-8.2,2.344-8.238,2.371a.528.528,0,0,1-.285.081Z",
    transform: "translate(125.595 6.696)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s",
    d: "M432.743,120.57a4.065,4.065,0,0,0-2.872-1.707,3.807,3.807,0,0,0-2.71,1.694l-.881-.569a4.85,4.85,0,0,1,3.631-2.168,5.23,5.23,0,0,1,3.726,2.127Z",
    transform: "translate(120.888 7.086)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M438.48,140.63l1.978,1.9a7.845,7.845,0,0,1,1.788,7.587,5.158,5.158,0,0,1-.352.881h0l-6.124,17.464L426.49,151.97S435.513,148.461,438.48,140.63Z",
    transform: "translate(120.963 15.181)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M423.418,141.21a12.194,12.194,0,0,0-3.184,9.823l1.07,10.216,7.479-9.579S424.109,149.407,423.418,141.21Z",
    transform: "translate(118.71 15.386)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "y",
    d: "M489.612,203.445a64.342,64.342,0,0,1-82.131,84c-1.45-.528-2.886-1.111-4.281-1.748a64.465,64.465,0,0,1-16.99-11.191q-1.49-1.355-2.886-2.8a64.193,64.193,0,0,1-13.549-21.136c-.3-.732-.569-1.477-.826-2.236a64.4,64.4,0,0,1,61.416-85.681c1.558,0,3.1.081,4.647.217a64.465,64.465,0,0,1,19.483,4.769c1.355.569,2.71,1.179,4.065,1.843a64,64,0,0,1,30.173,31.812C489.016,201.969,489.327,202.714,489.612,203.445Z",
    transform: "translate(99.259 22.994)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "z",
    d: "M467.757,186.324,424.6,286.584a64.248,64.248,0,0,1-17.274.312l49.4-112.805a63.932,63.932,0,0,1,11.029,12.234Z",
    transform: "translate(114.164 27.054)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "z",
    d: "M430.3,162.837l-48.775,111.64q-1.49-1.355-2.886-2.8L425.694,162.62C427.212,162.634,428.756,162.7,430.3,162.837Z",
    transform: "translate(103.983 22.984)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "z",
    d: "M448.6,168.143,397.561,286.11c-1.45-.528-2.886-1.111-4.281-1.748L444.588,166.3C445.943,166.869,447.285,167.479,448.6,168.143Z",
    transform: "translate(109.178 24.29)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M474.046,204.366c.284.745.555,1.477.813,2.222a51.484,51.484,0,0,1-95.68,37.6c-.312-.718-.623-1.45-.908-2.181a51.485,51.485,0,0,1,95.775-37.638Z",
    transform: "translate(102.807 26.802)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ab",
    d: "M474.573,205.882a51.484,51.484,0,0,1-29.888,64.491l-1.721.637a51.349,51.349,0,0,1-34.644-.19c-1.355-.5-2.71-1.057-4.064-1.68a51.267,51.267,0,0,1-16.177-11.774,46.651,46.651,0,0,1-3.157-3.753,50.776,50.776,0,0,1-6.016-10.134,51.484,51.484,0,0,1,29.875-64.545,50.944,50.944,0,0,1,14.9-3.428,51.484,51.484,0,0,1,20.2,2.547c1.355.461,2.71.989,4.065,1.572a52.026,52.026,0,0,1,14.348,9.281,51.119,51.119,0,0,1,10.473,13.44A27.2,27.2,0,0,1,474.573,205.882Z",
    transform: "translate(103.094 27.507)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "z",
    d: "M459.961,198.826,430.073,267.49A51.172,51.172,0,0,1,412.46,270.4l37.028-84.963a51.118,51.118,0,0,1,10.473,13.386Z",
    transform: "translate(115.984 31.082)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "z",
    d: "M421.427,175.51l-35.66,81.806a46.682,46.682,0,0,1-3.157-3.753l33.736-77.389A50.01,50.01,0,0,1,421.427,175.51Z",
    transform: "translate(105.392 27.558)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "z",
    d: "M440.665,178.962,400.955,270.1c-1.355-.5-2.71-1.057-4.065-1.68l39.684-91.033C437.942,177.851,439.324,178.379,440.665,178.962Z",
    transform: "translate(110.459 28.225)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M436.816,243.824l3.13,7.953-10.107,3.983-2.981-7.6c-7.343,2.385-15.052,3.184-20.323,2.222l.6-14.47a36.987,36.987,0,0,0,18.29-1.924c4.81-1.883,6.138-3.563,5.419-5.284-2.479-6.314-28.222,9.674-35.565-9.023-3.184-8.129,0-17.22,11.124-23.493l-3.076-7.8,10.107-3.983,3.021,7.682a40.349,40.349,0,0,1,16.177-1.572l-.271,14.267a33.2,33.2,0,0,0-15.445,1.761c-4.945,1.937-5.961,4-5.284,5.718,2.371,6.016,28.14-9.9,35.4,8.59C450.121,228.568,447.168,237.524,436.816,243.824Z",
    transform: "translate(109.471 30.713)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "y",
    d: "M435.836,241.95l3.13,7.967-10.107,3.97-2.994-7.6c-7.33,2.385-15.039,3.184-20.391,2.222l.61-14.47a37.014,37.014,0,0,0,18.358-1.924c4.8-1.883,6.124-3.563,5.419-5.284-2.466-6.3-28.208,9.687-35.565-9.023-3.184-8.129,0-17.22,11.123-23.493l-2.981-7.8,10.107-3.97,3.008,7.669a40.156,40.156,0,0,1,16.19-1.558l-.271,14.253a33.194,33.194,0,0,0-15.445,1.761c-4.945,1.937-5.961,4-5.284,5.717,2.371,6.016,28.127-9.89,35.4,8.6C449.128,226.722,446.187,235.65,435.836,241.95Z",
    transform: "translate(109.124 30.053)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M433.995,256.125c-.352-.881,1.612-3.617,3.631-6.083l-.258-.23c-3.075,3.048-8.536,8.129-9.118,6.07-.366-1.355,4.159-5.772,6.977-8.373-.136-.149-.257-.312-.393-.474-3.387,3.062-10.161,8.793-10.69,6.476-.352-1.545,5.541-6.625,8.644-9.172-.108-.149-.217-.284-.312-.434-2.994,2.479-8.874,7-9.4,4.7-.474-2.086,8.969-8.563,8.969-8.563h0l3.225-2.859s-.826-1.247-3.929-.379-5.487-.163-2.086-2.141c3.834-2.222,7.858-2.981,10.473-4.62s6.571-.176,6.571-.176l6.774,4.837s-6.26,12.573-12.451,16.475h0C437.964,254.214,434.618,257.669,433.995,256.125Z",
    transform: "translate(119.745 46.634)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M462.263,153.37s22.165,31.419,26.691,59.925c0,0-1.734,18.968-42.217,50.13a15.743,15.743,0,0,1-8.617-7.167s24.645-27.964,32.774-44.954c0,0-9.484-18.155-18.765-35.511C452.129,175.766,452.63,161,462.263,153.37Z",
    transform: "translate(125.09 19.702)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "u",
    d: "M367.185,201.077l-1.964-1.694s.176-6.016,2.425-7.072a1.856,1.856,0,0,1,2.195.542Z",
    transform: "translate(99.221 33.465)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M358.292,204.485a6.774,6.774,0,0,1,2.005-7.574,6.923,6.923,0,0,1,5.067-1.45c6.774.528,11.99,3.1,11.2,5.826-.285,1.03-4.065,1.666-7.059,1a26.7,26.7,0,0,0,6.91,1.355c3.577.135,2.845,4.688-1.653,4.552a20.743,20.743,0,0,1-5.23-.461,19.319,19.319,0,0,0,5.839,1.043c2.168-.19,2.3,3.265-1.965,3.428l-4.254.163,4.444.569c1.517.2,2.818,1.951-.2,2.913-2.385.745-8.956,2.33-10.758-.691a86.4,86.4,0,0,1-4.349-10.676Z",
    transform: "translate(96.61 34.623)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ac",
    d: "M164.94,148.73s18.887,26.935,28.018,46.444c16.082,20.607,15.757,32.964,29.725,47.772l-7.533,7-28.073-38.342c-1.517-2.507-4.065-5.65-5.69-8.522l-15.73-27.422Z",
    transform: "translate(28.151 18.055)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ad",
    d: "M132.314,104.71s-8.6,14.7-11.029,31.162-1.8,25.742,14.389,26.162c12.627.271,35.1,5.054,42.258-5.921S132.314,104.71,132.314,104.71Z",
    transform: "translate(12.286 2.434)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ae",
    d: "M148.535,238.76l-8.522,95.978c-7.33,8.319-14.334,28.94-16.258,51.078-1.016,11.963-4.728,32.381-6.354,40.957,3.631,1.829,7.14,3.9,10.73,5.8l30.728-75.791L183.842,238.76Z",
    transform: "translate(11.281 50.003)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "af",
    d: "M137.034,386.886c-3.414-3.78-6.544-6.937-7.736-8.129-1.585-1.585-6.5-2.263-10.229-2.547h-.081c-2.181,0-4.295,2.71-4.891,4.634a20.052,20.052,0,0,0-.664,8.224c.569,4.918,1.436,12.559,1.761,17.938h4.566l.352-12.871s16.773,13.86,26.447,12.817C153.156,406.261,144.431,395.083,137.034,386.886Z",
    transform: "translate(9.816 98.777)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ae",
    d: "M131.288,388.969c-6.354-2.384-11.381-9.1-13.738-12.749,3.726.285,8.644.962,10.229,2.547,1.192,1.179,4.322,4.336,7.736,8.129C135.448,388.969,134.31,390.107,131.288,388.969Z",
    transform: "translate(11.334 98.781)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ag",
    d: "M198.535,441.969c-4.281,3.021-13.549,3.536-13.549,3.536l-1.653-5.921h0c-.542-1.355-17.925-44.71-26.013-65.141a120.839,120.839,0,0,1-7.967-41.242c-12.627-34.291-26.528-69.883-25.837-91.71l30.064-10.961,17.247,95.165L196.57,437.227h0Z",
    transform: "translate(13.442 47.082)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "af",
    d: "M203.065,402.453c-9.227,3.076-28.574-6.869-28.574-6.869l1.992,10.839h-4.756s-2.886-8.549-4.891-14.375a40.51,40.51,0,0,1-1.68-13.007l1.165-.217c.8-.149,1.951-.352,3.279-.528a38.539,38.539,0,0,1,7.723-.447,7.48,7.48,0,0,1,2.425.542l.244.122.135.068c1.355.908,5.148,3.319,9.294,6.3C198.445,391.235,209.365,400.286,203.065,402.453Z",
    transform: "translate(28.219 99.347)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ag",
    d: "M185.465,387.806c-6.029-.881-15.35-5.785-19.415-8.983.8-.149,1.951-.352,3.279-.528a37.4,37.4,0,0,1,7.56-.664,5.623,5.623,0,0,1,2.832.881l.135.068c1.355.908,5.148,3.319,9.294,6.3C189.53,386.925,188.663,388.267,185.465,387.806Z",
    transform: "translate(28.545 99.28)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M123.69,222.407s-8.468,39.508,8.007,104.649c0,0,32.693,5.026,48.775-5.243,3.184-23.385,2.574-80.627,1.355-104.568C181.867,217.245,147.576,214.075,123.69,222.407Z",
    transform: "translate(12.741 42.158)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ah",
    d: "M182.669,202.78l.257,39.724c-15.8,13.657-58.177,5.162-58.177,5.162l7.587-36.215L118.53,159.737l9.335-4.7,1.9-.962h0l4.065-2.059,2.994-1.5,9.985-5.04,17.952,2.33,6.205.8,5.528.718,2.141.271,2.71.352.7,29.333a34.7,34.7,0,0,1,3.631,13.007,13.548,13.548,0,0,1-2.71,8.712h0l-.285.352V202.7Z",
    transform: "translate(11.682 16.898)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ag",
    d: "M160,147.76c-1.707,4.823-4.85,8.752-11.584,9.484a17.613,17.613,0,0,1-16.353-6.774l9.985-5.04Z",
    transform: "translate(16.483 16.884)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ai",
    d: "M175.091,186.8v1.45a83.568,83.568,0,0,1-19.1,4.376,78.589,78.589,0,0,1-15.445.19.8.8,0,0,1-.732-.854.813.813,0,0,1,.867-.732,81.292,81.292,0,0,0,34.671-4.769Z",
    transform: "translate(19.233 31.444)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ae",
    d: "M156.691,123.607s3.482-4.634,6.07-.8-1.07,15.174-7.411,12.41Z",
    transform: "translate(24.748 8.317)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M156.523,130.666a.528.528,0,0,0,.515-.393,8.292,8.292,0,0,1,4.634-4.932.515.515,0,0,0,.312-.691.542.542,0,0,0-.691-.312,9.308,9.308,0,0,0-5.3,5.65.556.556,0,0,0,.379.664Z",
    transform: "translate(24.97 9.388)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M159.689,128.331a.569.569,0,0,0,.285-.081.542.542,0,0,0,.163-.745,4.85,4.85,0,0,0-2.005-1.612.542.542,0,0,0-.718.271.528.528,0,0,0,.271.7,3.808,3.808,0,0,1,1.545,1.219A.555.555,0,0,0,159.689,128.331Z",
    transform: "translate(25.462 9.934)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ae",
    d: "M131.67,123.607s-3.482-4.634-6.07-.8,1.07,15.174,7.411,12.41Z",
    transform: "translate(13.893 8.317)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aj",
    d: "M131.273,130.665a.528.528,0,0,1-.515-.393,8.305,8.305,0,0,0-4.647-4.932.528.528,0,0,1-.312-.691.555.555,0,0,1,.691-.312,9.24,9.24,0,0,1,5.3,5.65.542.542,0,0,1-.366.664Z",
    transform: "translate(14.248 9.389)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aj",
    d: "M127.27,128.331a.583.583,0,0,1-.3-.081.542.542,0,0,1-.149-.745,4.851,4.851,0,0,1,2.005-1.612.534.534,0,0,1,.434.975,3.929,3.929,0,0,0-1.545,1.219.528.528,0,0,1-.447.244Z",
    transform: "translate(14.593 9.934)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ag",
    d: "M153.255,139.406v11.679s-4.065,5.338-8.576,4.932-7.9-6.124-7.9-6.124V139.054l4.728-.244Z",
    transform: "translate(18.158 14.535)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ae",
    d: "M153.255,139.4v5.745c-3.861,1.694-9.335,2.33-16.475,1.843v-7.926l4.728-.244Z",
    transform: "translate(18.158 14.538)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ag",
    d: "M128,121.009a112.988,112.988,0,0,0,1.463,14.24c.217,1.084.447,2.114.718,3.035,2.371,8.305,8.305,22.558,24.916,16.624,7.33-2.615,10.73-10.839,12.194-19.1a79.856,79.856,0,0,0,1.111-15.432,11.76,11.76,0,0,0-5.975-10.012c-9.8-5.555-20.147-3.482-26.962-.867A11.76,11.76,0,0,0,128,121.009Z",
    transform: "translate(15.039 3.193)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.81,124.061c0,1.206.623,2.181,1.355,2.181s1.355-.976,1.355-2.181-.61-2.181-1.355-2.181S148.81,122.856,148.81,124.061Z",
    transform: "translate(22.427 8.527)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.18,124.061c0,1.206.623,2.181,1.355,2.181s1.355-.976,1.355-2.181-.623-2.181-1.355-2.181S136.18,122.856,136.18,124.061Z",
    transform: "translate(17.945 8.527)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ad",
    d: "M153.374,118.931a22.816,22.816,0,0,0-5.921-.881,1.03,1.03,0,0,0-1.03,1.206h0a1.016,1.016,0,0,0,1.057.84,26.244,26.244,0,0,1,8.129,1,1.531,1.531,0,0,0-.474-1.111A3.5,3.5,0,0,0,153.374,118.931Z",
    transform: "translate(21.575 7.168)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ad",
    d: "M135.585,118.974a23.318,23.318,0,0,1,5.921-.894,1.03,1.03,0,0,1,1.03,1.206h0a1.043,1.043,0,0,1-1.057.854,25.743,25.743,0,0,0-8.129.989,1.517,1.517,0,0,1,.461-1.1,3.6,3.6,0,0,1,1.775-1.057Z",
    transform: "translate(16.941 7.179)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ae",
    d: "M143.593,133.584a2.249,2.249,0,0,0,1.165-.271,1.626,1.626,0,0,0,.786-1.355,77.776,77.776,0,0,0-.325-8.4.528.528,0,0,0-.569-.488.556.556,0,0,0-.5.583,75.659,75.659,0,0,1,.325,8.2.6.6,0,0,1-.257.5,3.292,3.292,0,0,1-2.154-.2.515.515,0,0,0-.691.285.542.542,0,0,0,.285.7A5.922,5.922,0,0,0,143.593,133.584Z",
    transform: "translate(19.772 8.949)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s",
    d: "M151.286,133.33c-.406,2.032-1.761,5.785-6.287,5.785s-5.826-3.428-6.259-5.785Z",
    transform: "translate(18.853 12.59)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ae",
    d: "M144.138,140.352a5.419,5.419,0,0,0,2.52-.732.542.542,0,0,0,.176-.732.528.528,0,0,0-.745-.176h0a4.349,4.349,0,0,1-1.951.569,4.62,4.62,0,0,1-2.046-.569.532.532,0,1,0-.555.908A5.419,5.419,0,0,0,144.138,140.352Z",
    transform: "translate(19.756 14.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ad",
    d: "M126.411,122.8a1.788,1.788,0,0,0,1.355.989,34.481,34.481,0,0,0,.2,3.97c.664,7.736,2.615,9.091,3.048,7.181a88.716,88.716,0,0,0,.135-10.934,25.742,25.742,0,0,0,2.832-.366l1.8-7.506.623,7.425c2.71.935,8.983-.569,8.983-.569l2.1-7.411,1.355,7.127a14.9,14.9,0,0,0,9.078.664l1.165-7.7,2.71,7.7s8.617,3.089,8.712,0c0-1.8-1.26-6.869-2.371-10.839a16.258,16.258,0,0,0-7.831-9.931c-10.69-5.731-21.989-2.71-25.878-.366C126.072,107.181,126.411,122.8,126.411,122.8Z",
    transform: "translate(14.478 0.519)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ad",
    d: "M156.274,105.13s7.343,8.441,9.674,23.507,5.568,26.2-3.509,31.162c-9.836,5.419-10.5-3.78-10.365-6.774s10.026-13.088,4.444-36.2C154.688,109.384,156.274,105.13,156.274,105.13Z",
    transform: "translate(23.58 2.583)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s",
    d: "M127.91,132.09a1.26,1.26,0,1,0,1.26-1.26,1.246,1.246,0,0,0-1.26,1.26Z",
    transform: "translate(15.01 11.703)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "y",
    d: "M235.1,200.863a64.41,64.41,0,0,1-50.13,87.171,63.675,63.675,0,0,1-17.274.325,64.57,64.57,0,0,1-14.66-3.536c-1.45-.528-2.886-1.125-4.295-1.761a64.575,64.575,0,0,1-16.976-11.177q-1.477-1.355-2.886-2.8a63.977,63.977,0,0,1-13.549-21.136c-.3-.732-.569-1.49-.826-2.236A64.423,64.423,0,0,1,175.869,160c1.558,0,3.1.095,4.647.23A64.07,64.07,0,0,1,200,165c1.355.556,2.71,1.179,4.065,1.829a64.356,64.356,0,0,1,13.115,8.712,63.544,63.544,0,0,1,11.029,12.194,64.362,64.362,0,0,1,6.029,10.839C234.507,199.386,234.819,200.131,235.1,200.863Z",
    transform: "translate(8.97 22.054)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ak",
    d: "M213.267,183.721,170.114,283.98a63.678,63.678,0,0,1-17.274.325l49.4-112.805a63.545,63.545,0,0,1,11.029,12.221Z",
    transform: "translate(23.857 26.135)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ak",
    d: "M175.811,160.244l-48.775,111.64q-1.477-1.355-2.886-2.8L171.163,160C172.722,160,174.266,160.108,175.811,160.244Z",
    transform: "translate(13.676 22.054)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ak",
    d: "M194.095,165.529,143.125,283.51c-1.45-.528-2.886-1.124-4.295-1.761L190.152,163.7C191.439,164.255,192.78,164.879,194.095,165.529Z",
    transform: "translate(18.885 23.367)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M219.891,202.659c.3.732.569,1.477.826,2.222a51.484,51.484,0,0,1-95.68,37.543c-.325-.7-.623-1.436-.921-2.168a51.484,51.484,0,1,1,95.775-37.638Z",
    transform: "translate(12.152 24.986)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ab",
    d: "M220.082,203.269a51.484,51.484,0,0,1-29.888,64.478c-.583.23-1.152.447-1.734.65a51.035,51.035,0,0,1-17.613,2.913,51.77,51.77,0,0,1-17.044-3.1c-1.355-.5-2.71-1.057-4.065-1.68a51.323,51.323,0,0,1-16.191-11.774c-1.1-1.192-2.154-2.452-3.157-3.753a51.09,51.09,0,0,1-6-10.148,51.485,51.485,0,0,1,39.738-67.269,49.579,49.579,0,0,1,5.081-.637,51.27,51.27,0,0,1,20.2,2.547c1.355.461,2.71.989,4.065,1.572a51.716,51.716,0,0,1,14.348,9.281,50.9,50.9,0,0,1,10.473,13.44A31.265,31.265,0,0,1,220.082,203.269Z",
    transform: "translate(12.788 26.598)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "z",
    d: "M205.42,196.24l-29.807,68.61A51.036,51.036,0,0,1,158,267.763L194.988,182.8a50.9,50.9,0,0,1,10.432,13.44Z",
    transform: "translate(25.688 30.145)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "z",
    d: "M166.94,172.91l-35.673,81.806c-1.1-1.192-2.154-2.452-3.157-3.753l33.722-77.416a49.566,49.566,0,0,1,5.108-.637Z",
    transform: "translate(15.081 26.635)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "z",
    d: "M186.179,176.412l-39.724,91.141c-1.355-.5-2.71-1.057-4.065-1.68l39.684-91.033A25.8,25.8,0,0,1,186.179,176.412Z",
    transform: "translate(20.149 27.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M182.307,241.224l3.13,7.953-10.094,3.97-2.981-7.587c-7.343,2.385-15.052,3.17-20.323,2.208l.6-14.456a37.015,37.015,0,0,0,18.358-1.924c4.81-1.883,6.137-3.563,5.419-5.284-2.479-6.314-28.222,9.674-35.578-9.037-3.17-8.129,0-17.207,11.137-23.48L148.9,185.77,159,181.8l3.021,7.669A40.334,40.334,0,0,1,178.2,187.91l-.271,14.267a33.193,33.193,0,0,0-15.445,1.761c-4.945,1.937-5.961,4.065-5.284,5.717,2.371,6.016,28.14-9.9,35.4,8.59C195.666,226,192.658,234.91,182.307,241.224Z",
    transform: "translate(19.184 29.79)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "y",
    d: "M181.346,239.336l3.13,7.953-10.121,3.983-2.981-7.587c-7.33,2.385-15.052,3.184-20.391,2.222l.61-14.416a37.029,37.029,0,0,0,18.358-1.924c4.8-1.883,6.124-3.563,5.419-5.284-2.479-6.314-28.222,9.674-35.565-9.023-3.184-8.129,0-17.22,11.123-23.493l-3.062-7.8,10.107-3.983,3.008,7.682a40.4,40.4,0,0,1,16.191-1.572l-.257,14.24a33.138,33.138,0,0,0-15.432,1.761c-4.945,1.937-5.961,4-5.284,5.717,2.357,6.016,28.127-9.9,35.389,8.59C194.678,224.108,191.7,233.036,181.346,239.336Z",
    transform: "translate(18.817 29.144)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ag",
    d: "M153.831,260.173c1.111-1.829-3.062-3.848-4.485-6s-4.186-8.319-2.8-8.82a18.849,18.849,0,0,1,4.322-.637c1.206-.135,2.791-1.531,1.91-2.249s-4.783-.948-6.585-.623a31.194,31.194,0,0,0-2.981,1.179,5.419,5.419,0,0,1-4.065.108c-.515-1.694-1.016-3.563-1.463-4.566-1.734-.772-9.484.244-9.931,4.241a56.788,56.788,0,0,0,1.436,6.232c4.187,11.313,9.023,13.372,10.961,14.334a2.845,2.845,0,0,0,3.374-.894,2.547,2.547,0,0,0,2.859-1.192c3.089.718,3.658-1.355,3.658-1.355S152.706,262,153.831,260.173Z",
    transform: "translate(14.954 49.848)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ah",
    d: "M135.393,169.643c-3.306,25.255-5.121,41.7-5.867,46.743a1.323,1.323,0,0,1-.108.664l-.122.732-3.807,1.274-.677.23h0l-9,3.021c-.135-.406-.271-.854-.393-1.355-4.769-17.058,4.688-64.87,4.688-64.87C130.054,151.691,135.393,169.643,135.393,169.643Z",
    transform: "translate(10.102 20.418)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ah",
    d: "M143.241,253.361a20.539,20.539,0,0,1-10.961,4.674c-9.484-22.436-15.418-37.407-17.22-53.368l5.988-1.355,2.073-.488h0l5.812-1.355.19.583q.122.339.284.854c1.165,3.672,4.349,14.118,7.086,25.268C139.867,241.872,143.241,253.361,143.241,253.361Z",
    transform: "translate(10.45 36.77)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ac",
    d: "M127.448,201.816l.19.583c-1.694.285-3.374.637-4.674.921h0c-1.45.325-2.439.569-2.466.583h-.244a1,1,0,0,1-.691-.284.908.908,0,0,1-.244-.447.976.976,0,0,1,.691-1.192c.244,0,3.888-.976,7.682-1.6a1.323,1.323,0,0,1-.108.664Z",
    transform: "translate(11.95 36.383)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ae",
    d: "M204.93,219.957l2.493-.7s2.385-5.528.8-7.438a1.856,1.856,0,0,0-2.222-.434Z",
    transform: "translate(42.341 40.218)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ag",
    d: "M216.322,227.664a6.774,6.774,0,0,0,1.355-7.709,6.91,6.91,0,0,0-3.983-3.455c-6.341-2.384-12.194-2.263-12.614.556-.176,1.057,2.994,3.225,5.975,3.888a26.608,26.608,0,0,1-6.774-1.748c-3.306-1.355-4.566,3.048-.434,4.823a19.894,19.894,0,0,0,4.932,1.788,19.2,19.2,0,0,1-5.731-1.5c-1.883-1.1-3.468,1.964.325,3.929l3.794,1.937-4.268-1.355c-1.463-.461-3.374.569-1.043,2.71,1.843,1.68,7.127,5.894,10.039,3.916A85.8,85.8,0,0,0,216.322,227.664Z",
    transform: "translate(39.444 41.507)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ab",
    d: "M360.531,391.552v.176a9.01,9.01,0,0,1-3.468,6.53,17.36,17.36,0,0,1-1.829,1.477,37.386,37.386,0,0,1-6.91,3.807c-.6.258-1.206.5-1.829.745q-3.17,1.26-6.91,2.33l-1.829.5c-2.181.6-4.5,1.125-6.923,1.626L329,409.1q-3.333.637-6.91,1.138l-1.829.258c-2.249.284-4.552.542-6.923.759l-1.815.162c-2.263.176-4.579.325-6.923.434-.61,0-1.206.068-1.829.081-2.263.095-4.579.135-6.91.149h-1.856c-2.344,0-4.647,0-6.923-.122h-1.816c-1.734-.081-3.441-.176-5.135-.3l-1.788-.136-1.829-.149c-2.357-.2-4.674-.447-6.91-.732l-1.829-.244c-1.436-.2-2.832-.42-4.214-.637l-2.71-.474-1.815-.352c-2.425-.488-4.742-1.016-6.923-1.585l-1.287-.339-.542-.149c-.989-.284-1.951-.569-2.886-.867-1.355-.447-2.71-.908-4.065-1.355l-1.829-.732a41.039,41.039,0,0,1-6.137-3.13l-.786-.5-.908-.65-.921-.718c-2.628-2.208-4.065-4.579-4.065-7.072V377.15H360.531v14.4Z",
    transform: "translate(50.773 99.111)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M233.549,377.144v23.033l-.908-.65-.921-.718V377.13Z",
    transform: "translate(51.848 99.104)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M240.009,377.13v27.409l-1.829-.732V377.13Z",
    transform: "translate(54.14 99.104)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M246.479,377.12v30.173l-1.287-.339-.542-.149V377.12Z",
    transform: "translate(56.436 99.1)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M252.905,377.11v32.124l-1.815-.352V377.11Z",
    transform: "translate(58.721 99.097)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M259.369,377.1v33.492l-1.829-.244V377.1Z",
    transform: "translate(61.01 99.093)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M265.819,377.09v34.386l-1.829-.149V377.09Z",
    transform: "translate(63.299 99.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M272.266,377.08v34.9H270.45v-34.82Z",
    transform: "translate(65.591 99.086)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M278.729,377.07v35.036H276.9V377.084Z",
    transform: "translate(67.88 99.083)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M285.179,377.06v34.82c-.61,0-1.206.068-1.829.081V377.074Z",
    transform: "translate(70.169 99.079)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M291.625,377.05v34.237l-1.816.163V377.064Z",
    transform: "translate(72.461 99.075)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M298.089,377v33.234l-1.829.257V377.068Z",
    transform: "translate(74.75 99.058)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M304.539,377v31.744l-1.829.352V377Z",
    transform: "translate(77.039 99.058)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M311,377v29.671l-1.829.5V377Z",
    transform: "translate(79.331 99.058)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M317.479,377v26.569c-.6.258-1.206.5-1.829.745V377Z",
    transform: "translate(81.631 99.058)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M323.9,377v21.3a17.378,17.378,0,0,1-1.829,1.477V377Z",
    transform: "translate(83.909 99.058)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "y",
    d: "M360.51,382.027c0,10.337-29.5,18.711-65.873,18.711-4.972,0-9.809-.149-14.47-.447-5.853-.379-11.421-.975-16.57-1.748-4.593-.7-8.861-1.558-12.736-2.534-1.179-.3-2.317-.61-3.414-.921a55.3,55.3,0,0,1-11.99-4.837c-.61-.352-1.179-.7-1.707-1.07-3.211-2.195-4.986-4.62-4.986-7.154a3.947,3.947,0,0,1,0-.691c1.274-10.012,30.254-18.006,65.819-18.006a217.619,217.619,0,0,1,24.74,1.355l4.349.555a132.484,132.484,0,0,1,16.759,3.36c1.084.3,2.127.61,3.143.921a55.553,55.553,0,0,1,9.227,3.753,19.47,19.47,0,0,1,5.921,4.485,7.155,7.155,0,0,1,1.68,3.577A3.962,3.962,0,0,1,360.51,382.027Z",
    transform: "translate(50.794 94.207)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ak",
    d: "M349.611,375.175,271.03,397.706c-5.853-.379-11.421-.975-16.57-1.748l89.258-25.268A19.467,19.467,0,0,1,349.611,375.175Z",
    transform: "translate(59.917 96.819)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ak",
    d: "M322.386,364.885,234.117,389.9c-.61-.352-1.179-.7-1.707-1.07l85.627-24.5Z",
    transform: "translate(52.093 94.562)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ak",
    d: "M338.715,368.141l-92.821,26.487c-1.179-.3-2.317-.61-3.414-.921l93.038-26.487C336.67,367.518,337.7,367.83,338.715,368.141Z",
    transform: "translate(55.666 95.587)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M343.764,381.033a5.9,5.9,0,0,1,0,.691c-1.273,7.926-24.387,14.267-52.6,14.267s-51.322-6.341-52.6-14.267a5.932,5.932,0,0,1,0-.691c0-8.237,23.615-14.9,52.65-14.9S343.764,372.8,343.764,381.033Z",
    transform: "translate(54.276 95.2)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ab",
    d: "M343.707,381.387c-1.274,7.926-24.387,14.267-52.6,14.267h-1.829a170.128,170.128,0,0,1-17.857-1.07,119.619,119.619,0,0,1-15.066-2.71c-1.125-.285-2.208-.583-3.252-.881a37.611,37.611,0,0,1-11-4.9,13.905,13.905,0,0,1-1.612-1.355,6.314,6.314,0,0,1-1.924-3.387c1.274-7.926,24.387-14.267,52.6-14.267,3.563,0,7.059.108,10.432.3,1.721.095,3.428.217,5.081.366a129.233,129.233,0,0,1,18.291,2.832c1.152.271,2.263.569,3.319.867a45.1,45.1,0,0,1,10.189,4.065,11.287,11.287,0,0,1,4.959,4.742A4.4,4.4,0,0,1,343.707,381.387Z",
    transform: "translate(54.279 95.538)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "z",
    d: "M334.8,378.052,280.607,393.43a170.106,170.106,0,0,1-17.857-1.07L329.8,373.31a11.287,11.287,0,0,1,5,4.742Z",
    transform: "translate(62.859 97.748)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "z",
    d: "M306.135,367.7l-64.572,18.345a13.9,13.9,0,0,1-1.612-1.355l61.1-17.356C302.775,367.425,304.482,367.547,306.135,367.7Z",
    transform: "translate(54.768 95.626)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "z",
    d: "M324.441,370.557l-71.929,20.431c-1.125-.284-2.208-.583-3.252-.881l71.807-20.418C322.273,369.961,323.425,370.259,324.441,370.557Z",
    transform: "translate(58.072 96.464)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M290.965,388.262v2.479h-11.11V388.37A145.871,145.871,0,0,1,259.6,386.8l5.988-3.848a117.6,117.6,0,0,0,18.209,1.436c5.284,0,7.167-.312,7.167-.854,0-1.965-30.5-.379-30.5-6.219,0-2.533,6.463-4.661,19.388-5.176V369.7h11.11v2.4a129.343,129.343,0,0,1,16,1.355l-5.6,3.821a107.489,107.489,0,0,0-15.364-1.165c-5.419,0-7.167.447-7.167.989,0,1.883,30.5.312,30.5,6.083C309.337,385.552,303.186,387.72,290.965,388.262Z",
    transform: "translate(61.741 96.467)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "y",
    d: "M290.721,387.652v2.479h-11.11V387.76a145.65,145.65,0,0,1-20.241-1.572l5.988-3.848a117.294,117.294,0,0,0,18.2,1.436c5.284,0,7.167-.312,7.167-.854,0-1.965-30.484-.379-30.484-6.219,0-2.534,6.449-4.661,19.374-5.176V369.09h11.11v2.4a129.125,129.125,0,0,1,16,1.355l-5.6,3.821a107.484,107.484,0,0,0-15.364-1.165c-5.419,0-7.167.447-7.167.989,0,1.883,30.5.312,30.5,6.083C309.093,384.942,302.942,387.042,290.721,387.652Z",
    transform: "translate(61.66 96.251)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ab",
    d: "M363.492,374.512v.19a9.037,9.037,0,0,1-3.455,6.53,23.43,23.43,0,0,1-1.829,1.477,37.538,37.538,0,0,1-6.923,3.793c-.583.257-1.192.515-1.816.759-2.114.826-4.43,1.612-6.923,2.33l-1.829.5c-2.181.583-4.5,1.125-6.91,1.626l-1.829.352c-2.222.42-4.539.8-6.923,1.138l-1.815.258c-2.249.284-4.552.542-6.923.759l-1.829.163c-2.263.176-4.566.325-6.91.434l-1.829.081c-2.276.081-4.579.136-6.923.149H297.1c-2.344,0-4.647,0-6.923-.122l-1.829-.081c-1.734-.068-3.441-.176-5.121-.284l-1.788-.135-1.829-.149c-2.371-.2-4.674-.461-6.923-.745q-.921-.095-1.829-.244c-1.355-.19-2.832-.406-4.2-.637-.921-.149-1.816-.3-2.71-.474l-1.829-.339c-2.412-.488-4.729-1.016-6.923-1.585l-1.274-.339-.542-.149c-.989-.284-1.951-.569-2.886-.867-1.355-.447-2.71-.921-4.065-1.355l-1.829-.732a41.453,41.453,0,0,1-6.124-3.13c-.271-.163-.542-.339-.786-.515s-.623-.42-.921-.637-.623-.488-.908-.732c-2.642-2.195-4.065-4.579-4.065-7.059V360.11H363.492v14.4Z",
    transform: "translate(51.876 93.064)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M236.609,360.113v23.033c-.325-.2-.623-.42-.921-.637s-.623-.488-.908-.732V360.1Z",
    transform: "translate(52.934 93.061)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M243.059,360.1v27.409l-1.829-.732V360.1Z",
    transform: "translate(55.222 93.061)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M249.475,360.09v30.173l-1.274-.339-.542-.149V360.09Z",
    transform: "translate(57.504 93.057)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M255.969,360.08v32.11l-1.829-.339V360.08Z",
    transform: "translate(59.804 93.054)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M262.419,360.07v33.478q-.921-.095-1.829-.244V360.07Z",
    transform: "translate(62.092 93.05)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M268.879,360.06v34.386l-1.829-.149V360.06Z",
    transform: "translate(64.385 93.046)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M275.329,360.05v34.9l-1.829-.081V360.05Z",
    transform: "translate(66.674 93.043)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M281.761,360v35.091H280V360Z",
    transform: "translate(68.98 93.025)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M288.239,360v34.82l-1.829.081V360Z",
    transform: "translate(71.255 93.025)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M294.689,360v34.237l-1.829.163V360Z",
    transform: "translate(73.544 93.025)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M301.136,360v33.235l-1.815.257V360Z",
    transform: "translate(75.836 93.025)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M307.6,360v31.758l-1.829.352V360Z",
    transform: "translate(78.125 93.025)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M314.049,360v29.644l-1.829.5V360Z",
    transform: "translate(80.414 93.025)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M320.476,360v26.569c-.583.257-1.192.515-1.815.759V360Z",
    transform: "translate(82.699 93.025)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M326.959,360v21.271a23.4,23.4,0,0,1-1.829,1.477V360Z",
    transform: "translate(84.995 93.025)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "y",
    d: "M363.507,365c0,10.338-29.482,18.711-65.873,18.711-4.959,0-9.809-.163-14.456-.461-5.866-.366-11.421-.962-16.57-1.748-4.606-.691-8.874-1.545-12.736-2.52-1.179-.3-2.33-.61-3.428-.935a55.222,55.222,0,0,1-11.99-4.823c-.6-.352-1.165-.7-1.694-1.07-3.211-2.195-4.986-4.62-4.986-7.154a3.953,3.953,0,0,1,0-.691c1.274-10.012,30.254-18.02,65.805-18.02a217.3,217.3,0,0,1,24.74,1.355c1.477.176,2.926.352,4.349.555a133.191,133.191,0,0,1,16.773,3.36c1.084.3,2.127.61,3.13.921a55.084,55.084,0,0,1,9.227,3.753,19.552,19.552,0,0,1,5.934,4.485A6.965,6.965,0,0,1,363.4,364.3,3.956,3.956,0,0,1,363.507,365Z",
    transform: "translate(51.862 88.16)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ak",
    d: "M352.671,358.175,274.09,380.692c-5.866-.366-11.421-.962-16.57-1.748l89.244-25.254A19.551,19.551,0,0,1,352.671,358.175Z",
    transform: "translate(61.003 90.786)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ak",
    d: "M325.432,347.855l-88.269,25.011c-.6-.352-1.165-.7-1.694-1.07l85.613-24.5C322.56,347.476,324.01,347.652,325.432,347.855Z",
    transform: "translate(53.179 88.518)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ak",
    d: "M341.751,351.111,249,377.6c-1.179-.3-2.33-.61-3.428-.935l93.051-26.474C339.705,350.488,340.749,350.8,341.751,351.111Z",
    transform: "translate(56.763 89.544)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M346.817,364a5.878,5.878,0,0,1,0,.691c-1.274,7.926-24.387,14.267-52.6,14.267s-51.335-6.341-52.609-14.267a5.9,5.9,0,0,1,0-.691c0-8.238,23.615-14.9,52.65-14.9S346.817,355.739,346.817,364Z",
    transform: "translate(55.355 89.157)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ab",
    d: "M346.792,364.343c-1.274,7.926-24.387,14.267-52.6,14.267h-1.91a170.481,170.481,0,0,1-17.871-1.084,119.509,119.509,0,0,1-15.052-2.642q-1.694-.42-3.252-.894a37.015,37.015,0,0,1-11.015-4.9,12.515,12.515,0,0,1-1.6-1.355,6.341,6.341,0,0,1-1.937-3.374c1.274-7.926,24.387-14.267,52.609-14.267,3.563,0,7.059.095,10.432.3q2.574.136,5.081.366a129.546,129.546,0,0,1,18.29,2.832c1.138.271,2.249.556,3.319.867a45.359,45.359,0,0,1,10.188,4.065,11.244,11.244,0,0,1,4.945,4.742,4.877,4.877,0,0,1,.366,1.084Z",
    transform: "translate(55.34 89.509)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "z",
    d: "M337.875,361.022,283.681,376.4a170.452,170.452,0,0,1-17.87-1.084l67.065-19.036a11.245,11.245,0,0,1,5,4.742Z",
    transform: "translate(63.945 91.705)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "z",
    d: "M309.195,350.666,244.609,369a12.531,12.531,0,0,1-1.6-1.355l61.1-17.342Q306.675,350.449,309.195,350.666Z",
    transform: "translate(55.854 89.583)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "z",
    d: "M327.5,353.527l-71.929,20.431q-1.694-.42-3.252-.894l71.807-20.4C325.32,352.931,326.4,353.216,327.5,353.527Z",
    transform: "translate(59.158 90.421)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M294.025,371.218v2.493h-11.11V371.34a145.683,145.683,0,0,1-20.255-1.572l5.989-3.848a119.3,119.3,0,0,0,18.209,1.436c5.27,0,7.167-.325,7.167-.854,0-1.978-30.5-.379-30.5-6.219,0-2.534,6.463-4.661,19.388-5.176V352.67h11.11v2.4a127,127,0,0,1,16,1.355l-5.6,3.821a107.818,107.818,0,0,0-15.378-1.165c-5.419,0-7.167.447-7.167.989,0,1.883,30.5.312,30.5,6.083C312.383,368.508,306.232,370.622,294.025,371.218Z",
    transform: "translate(62.827 90.424)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "y",
    d: "M293.785,370.608V373.1h-11.11V370.73a145.7,145.7,0,0,1-20.255-1.572l5.988-3.848a119.274,119.274,0,0,0,18.209,1.436c5.27,0,7.167-.325,7.167-.853,0-1.978-30.5-.379-30.5-6.219,0-2.534,6.463-4.661,19.388-5.176V352.06h11.11v2.4a126.983,126.983,0,0,1,16,1.355l-5.6,3.821a107.757,107.757,0,0,0-15.364-1.165c-5.419,0-7.181.447-7.181.989,0,1.883,30.5.312,30.5,6.083C312.143,367.9,306.006,370.012,293.785,370.608Z",
    transform: "translate(62.742 90.208)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ab",
    d: "M363.132,357.482v.19a9.037,9.037,0,0,1-3.468,6.53,19.268,19.268,0,0,1-1.829,1.477,37.388,37.388,0,0,1-6.91,3.794l-1.829.759q-3.17,1.246-6.923,2.317c-.6.176-1.192.352-1.815.515-2.181.583-4.5,1.125-6.923,1.612l-1.829.366q-3.333.623-6.91,1.138l-1.829.244c-2.249.3-4.552.555-6.923.772l-1.816.149c-2.263.19-4.579.339-6.923.447l-1.829.081c-2.263.081-4.579.135-6.91.149h-1.829c-2.344,0-4.647,0-6.923-.135H287.9c-1.734-.068-3.441-.176-5.135-.285l-1.788-.135-1.829-.149c-2.357-.217-4.674-.461-6.91-.745l-1.829-.244c-1.436-.19-2.832-.407-4.214-.637l-2.71-.474-1.816-.352c-2.425-.474-4.742-1-6.923-1.572l-1.355-.339-.542-.163q-1.49-.406-2.886-.854c-1.355-.447-2.71-.921-4.065-1.355q-.948-.352-1.829-.732a42.384,42.384,0,0,1-6.138-3.116c-.271-.163-.528-.339-.786-.515l-.908-.65c-.325-.23-.623-.474-.921-.718-2.628-2.195-4.065-4.579-4.065-7.059V343.08H362.969v14.592Z",
    transform: "translate(51.681 87.021)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M236.159,343.084v23.033l-.908-.65c-.325-.23-.623-.474-.921-.718V343.07Z",
    transform: "translate(52.774 87.017)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M242.619,343.07v27.4q-.948-.352-1.829-.732V343.07Z",
    transform: "translate(55.066 87.017)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M249.087,343.06v30.173l-1.355-.339-.542-.163V343.06Z",
    transform: "translate(57.337 87.014)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M255.476,343.05v32.11l-1.815-.352V343.05Z",
    transform: "translate(59.633 87.01)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M261.979,343v33.478l-1.829-.244V343Z",
    transform: "translate(61.936 86.993)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M268.479,343v34.386l-1.829-.149V343Z",
    transform: "translate(64.243 86.993)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M274.876,343v34.887H273.06V343Z",
    transform: "translate(66.518 86.993)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M281.339,343v35.037H279.51V343Z",
    transform: "translate(68.806 86.993)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M287.789,343v34.82l-1.829.081V343Z",
    transform: "translate(71.095 86.993)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M294.236,343v34.237l-1.815.149V343Z",
    transform: "translate(73.388 86.993)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M300.7,343v33.235l-1.829.244V343Z",
    transform: "translate(75.676 86.993)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M307.149,343v31.7l-1.829.366V343Z",
    transform: "translate(77.965 86.993)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M313.6,343v29.631c-.6.176-1.192.352-1.815.515V343Z",
    transform: "translate(80.257 86.993)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M320.059,343v26.569l-1.829.759V343Z",
    transform: "translate(82.546 86.993)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M326.479,342.94v21.312a19.26,19.26,0,0,1-1.829,1.477V342.94Z",
    transform: "translate(84.825 86.971)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "y",
    d: "M363.09,347.971c0,10.324-29.5,18.711-65.873,18.711-4.972,0-9.809-.163-14.47-.461-5.853-.366-11.421-.962-16.57-1.748-4.593-.691-8.861-1.545-12.736-2.52q-1.775-.447-3.414-.935a54.668,54.668,0,0,1-11.991-4.823c-.61-.352-1.179-.7-1.707-1.07-3.211-2.208-4.986-4.62-4.986-7.154a3.959,3.959,0,0,1,0-.691c1.274-10.012,30.254-18.02,65.819-18.02a217.519,217.519,0,0,1,24.74,1.355c1.477.163,2.926.352,4.349.555a132.493,132.493,0,0,1,16.759,3.36c1.084.3,2.127.6,3.143.921a55.553,55.553,0,0,1,9.227,3.739,19.7,19.7,0,0,1,5.921,4.5,7.1,7.1,0,0,1,1.68,3.577,3.979,3.979,0,0,1,.108.7Z",
    transform: "translate(51.709 82.117)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ak",
    d: "M352.221,341.1,273.64,363.616c-5.853-.366-11.421-.962-16.57-1.748L346.328,336.6A19.7,19.7,0,0,1,352.221,341.1Z",
    transform: "translate(60.843 84.722)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ak",
    d: "M325,330.826l-88.269,25.011c-.61-.352-1.179-.7-1.707-1.07l85.627-24.5C322.124,330.433,323.573,330.622,325,330.826Z",
    transform: "translate(53.019 82.475)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ak",
    d: "M341.311,334.081l-92.767,26.487q-1.775-.447-3.414-.935l93.038-26.474C339.252,333.458,340.295,333.756,341.311,334.081Z",
    transform: "translate(56.606 83.501)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M346.374,346.973a5.919,5.919,0,0,1,0,.691c-1.273,7.926-24.387,14.267-52.6,14.267s-51.322-6.341-52.6-14.267a5.932,5.932,0,0,1,0-.691c0-8.251,23.615-14.9,52.65-14.9S346.374,338.749,346.374,346.973Z",
    transform: "translate(55.202 83.114)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ab",
    d: "M346.331,347.327c-1.274,7.926-24.387,14.267-52.6,14.267h-1.883A173.732,173.732,0,0,1,274,360.51a117.2,117.2,0,0,1-15.066-2.71c-1.125-.271-2.208-.569-3.252-.881a37.256,37.256,0,0,1-11-4.9,12.675,12.675,0,0,1-1.612-1.355,6.274,6.274,0,0,1-1.924-3.374c1.274-7.926,24.387-14.267,52.6-14.267,3.563,0,7.059.095,10.432.285,1.721.108,3.414.23,5.081.379a125.741,125.741,0,0,1,18.291,2.832c1.152.271,2.263.555,3.319.867a45.129,45.129,0,0,1,10.188,4.065,11.381,11.381,0,0,1,4.959,4.756,4.251,4.251,0,0,1,.325,1.124Z",
    transform: "translate(55.191 83.451)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "z",
    d: "M337.411,344l-54.194,15.378a173.722,173.722,0,0,1-17.857-1.084l67.052-19.049a11.381,11.381,0,0,1,5,4.755Z",
    transform: "translate(63.785 85.658)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "z",
    d: "M308.745,333.639l-64.572,18.331a12.69,12.69,0,0,1-1.612-1.355l61.1-17.356C305.385,333.368,307.078,333.49,308.745,333.639Z",
    transform: "translate(55.694 83.536)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "z",
    d: "M327.051,336.5l-71.929,20.418c-1.125-.271-2.208-.569-3.252-.881l71.807-20.4A31.36,31.36,0,0,1,327.051,336.5Z",
    transform: "translate(58.998 84.377)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M293.593,354.188v2.479h-11.11V354.3a146.183,146.183,0,0,1-20.323-1.558l5.988-3.848a119.368,119.368,0,0,0,18.209,1.423c5.284,0,7.167-.312,7.167-.84,0-1.978-30.5-.393-30.5-6.232,0-2.52,6.463-4.647,19.388-5.162V335.64h11.11v2.385a129.153,129.153,0,0,1,16,1.355l-5.582,3.78a107.486,107.486,0,0,0-15.364-1.165c-5.419,0-7.167.447-7.167.989,0,1.87,30.5.312,30.5,6.083C311.964,351.478,305.813,353.592,293.593,354.188Z",
    transform: "translate(62.65 84.381)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "y",
    d: "M293.324,353.589v2.479h-11.11V353.7A145.962,145.962,0,0,1,262,352.139l5.988-3.848a119.032,119.032,0,0,0,18.2,1.423c5.284,0,7.167-.312,7.167-.84,0-1.978-30.484-.393-30.484-6.232,0-2.52,6.449-4.647,19.374-5.162V335h11.11v2.385a129.117,129.117,0,0,1,16,1.355l-5.6,3.834a107.473,107.473,0,0,0-15.364-1.165c-5.419,0-7.167.447-7.167.989,0,1.87,30.5.312,30.5,6.083C311.7,350.879,305.545,352.992,293.324,353.589Z",
    transform: "translate(62.593 84.154)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ab",
    d: "M360.694,342.252v.19a9.01,9.01,0,0,1-3.468,6.517,17.364,17.364,0,0,1-1.829,1.477,36.579,36.579,0,0,1-6.91,3.807c-.6.257-1.206.5-1.829.745q-3.171,1.26-6.91,2.33l-1.829.515c-2.181.583-4.5,1.124-6.923,1.612l-1.829.352c-2.222.42-4.525.813-6.91,1.138l-1.829.257c-2.249.284-4.552.542-6.923.759l-1.815.163c-2.263.19-4.579.339-6.923.447h-1.829c-2.263.095-4.579.135-6.91.149H294.2c-2.344,0-4.647,0-6.923-.135l-1.816-.068c-1.734-.081-3.441-.176-5.135-.3l-1.788-.122-1.829-.163c-2.357-.2-4.674-.447-6.91-.732l-1.829-.244c-1.436-.2-2.832-.406-4.214-.637l-2.71-.474-1.816-.352c-2.425-.474-4.742-1-6.923-1.585l-1.287-.339-.542-.149c-.989-.271-1.951-.569-2.886-.867-1.355-.447-2.71-.908-4.065-1.355l-1.829-.732a42.362,42.362,0,0,1-6.138-3.116l-.786-.515-.908-.65c-.325-.23-.623-.474-.921-.718-2.628-2.195-4.065-4.579-4.065-7.059V327.85H360.6v14.605Z",
    transform: "translate(50.84 81.617)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M233.739,327.843v23.033l-.908-.65c-.325-.23-.623-.474-.921-.718V327.83Z",
    transform: "translate(51.915 81.61)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M240.2,327.83v27.409l-1.829-.732V327.83Z",
    transform: "translate(54.208 81.61)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M246.649,327.82v30.173l-1.287-.339-.542-.149V327.82Z",
    transform: "translate(56.496 81.606)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M253.1,327.81v32.124l-1.816-.352V327.81Z",
    transform: "translate(58.789 81.602)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M259.559,327.8v33.492l-1.829-.244V327.813Z",
    transform: "translate(61.078 81.599)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M266.009,327.79v34.4l-1.829-.163V327.8Z",
    transform: "translate(63.366 81.595)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M272.476,327.78v34.9l-1.815-.068v-34.82Z",
    transform: "translate(65.666 81.592)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M278.919,327.77v35.036H277.09V327.784Z",
    transform: "translate(67.948 81.588)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M285.369,327.77v34.82H283.54V327.77Z",
    transform: "translate(70.236 81.588)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M291.816,327.76v34.2l-1.815.163V327.76Z",
    transform: "translate(72.529 81.585)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M298.279,327.75v33.221l-1.829.257V327.75Z",
    transform: "translate(74.818 81.581)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M304.729,327.74v31.744l-1.829.352v-32.1Z",
    transform: "translate(77.106 81.578)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M311.189,327.73v29.631l-1.829.515V327.73Z",
    transform: "translate(79.399 81.574)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M317.639,327.72v26.569c-.6.257-1.206.5-1.829.745V327.72Z",
    transform: "translate(81.688 81.57)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M324.089,327.71v21.3a17.354,17.354,0,0,1-1.829,1.477V327.71Z",
    transform: "translate(83.976 81.567)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "y",
    d: "M360.67,332.741c0,10.324-29.5,18.7-65.873,18.7-4.972,0-9.809-.149-14.47-.447-5.853-.379-11.421-.962-16.57-1.748-4.593-.7-8.861-1.558-12.736-2.534-1.179-.3-2.317-.61-3.414-.921a54.62,54.62,0,0,1-11.991-4.837q-.921-.528-1.707-1.057c-3.211-2.208-4.986-4.62-4.986-7.154a4.065,4.065,0,0,1,0-.7c1.274-10,30.254-18.006,65.819-18.006a217.49,217.49,0,0,1,24.74,1.355c1.477.163,2.927.352,4.349.542a134.918,134.918,0,0,1,16.76,3.36c1.084.3,2.127.61,3.143.935a54.447,54.447,0,0,1,9.227,3.739,19.467,19.467,0,0,1,5.921,4.484,7.208,7.208,0,0,1,1.68,3.577A4.064,4.064,0,0,1,360.67,332.741Z",
    transform: "translate(50.85 76.712)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ak",
    d: "M349.8,325.855,271.22,348.386c-5.853-.379-11.421-.962-16.57-1.748l89.258-25.268A19.47,19.47,0,0,1,349.8,325.855Z",
    transform: "translate(59.985 79.317)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ak",
    d: "M322.562,315.6l-88.255,25.011q-.921-.528-1.707-1.057L318.227,315C319.7,315.217,321.208,315.406,322.562,315.6Z",
    transform: "translate(52.16 77.057)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ak",
    d: "M338.891,318.855l-92.767,26.474c-1.179-.3-2.317-.61-3.414-.921l93.038-26.487C336.832,318.218,337.943,318.53,338.891,318.855Z",
    transform: "translate(55.748 78.093)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M343.954,331.743a5.408,5.408,0,0,1,0,.677c-1.273,7.926-24.387,14.267-52.6,14.267s-51.322-6.341-52.6-14.267a5.419,5.419,0,0,1,0-.677c0-8.251,23.615-14.9,52.65-14.9S343.954,323.492,343.954,331.743Z",
    transform: "translate(54.343 77.71)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ab",
    d: "M343.911,332.087c-1.274,7.926-24.387,14.267-52.6,14.267h-1.883a170.117,170.117,0,0,1-17.857-1.07,119.589,119.589,0,0,1-15.066-2.71c-1.125-.285-2.208-.583-3.252-.881a37.607,37.607,0,0,1-11-4.9,13.914,13.914,0,0,1-1.612-1.355,6.313,6.313,0,0,1-1.924-3.387c1.274-7.926,24.387-14.267,52.6-14.267,3.563,0,7.059.108,10.432.3,1.721.095,3.428.217,5.081.366a129.566,129.566,0,0,1,18.291,2.832c1.152.285,2.263.569,3.319.867a45.105,45.105,0,0,1,10.189,4.065,11.286,11.286,0,0,1,4.959,4.742A4.406,4.406,0,0,1,343.911,332.087Z",
    transform: "translate(54.332 78.043)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "z",
    d: "M334.991,328.755,280.8,344.133a170.115,170.115,0,0,1-17.857-1.07L330.032,324A11.286,11.286,0,0,1,334.991,328.755Z",
    transform: "translate(62.926 80.25)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "z",
    d: "M306.335,318.406l-64.572,18.345a13.92,13.92,0,0,1-1.612-1.355L301.24,318C302.961,318.135,304.668,318.257,306.335,318.406Z",
    transform: "translate(54.839 78.121)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "z",
    d: "M324.631,321.227,252.7,341.658c-1.125-.285-2.208-.583-3.252-.881l71.807-20.418C322.463,320.685,323.574,320.97,324.631,321.227Z",
    transform: "translate(58.139 78.959)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M291.155,338.969v2.479h-11.11v-2.371a145.882,145.882,0,0,1-20.255-1.6l5.988-3.848a117.608,117.608,0,0,0,18.209,1.436c5.284,0,7.167-.312,7.167-.854,0-1.965-30.5-.379-30.5-6.219,0-2.534,6.463-4.661,19.388-5.176V320.38h11.11v2.4a129.332,129.332,0,0,1,16,1.355l-5.6,3.861a109.384,109.384,0,0,0-15.364-1.152c-5.419,0-7.167.447-7.167.975,0,1.883,30.484.312,30.484,6.083C309.513,336.259,303.43,338.359,291.155,338.969Z",
    transform: "translate(61.809 78.966)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "y",
    d: "M290.911,338.352v2.479H279.8V338.46a145.654,145.654,0,0,1-20.242-1.572l5.989-3.848a117.3,117.3,0,0,0,18.2,1.436c5.284,0,7.167-.312,7.167-.854,0-1.965-30.484-.379-30.484-6.219,0-2.534,6.449-4.661,19.374-5.175V319.79h11.11v2.4a129.123,129.123,0,0,1,16,1.355l-5.6,3.821a109.372,109.372,0,0,0-15.364-1.152c-5.419,0-7.167.447-7.167.976,0,1.883,30.5.312,30.5,6.083C309.283,335.642,303.132,337.688,290.911,338.352Z",
    transform: "translate(61.727 78.756)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ab",
    d: "M360.335,324.282v.19a9.065,9.065,0,0,1-3.469,6.53,17.279,17.279,0,0,1-1.829,1.463,36.592,36.592,0,0,1-6.91,3.807c-.6.257-1.206.5-1.829.745q-3.17,1.26-6.91,2.33l-1.815.5c-2.181.583-4.5,1.124-6.923,1.612l-1.829.366q-3.333.623-6.91,1.138l-1.829.244c-2.249.3-4.552.542-6.923.759-.6.068-1.206.108-1.815.163-2.263.19-4.579.339-6.923.447l-1.829.081c-2.263.081-4.579.136-6.91.149h-1.829c-2.344,0-4.647,0-6.923-.135l-1.816-.068c-1.734-.081-3.441-.176-5.135-.3l-1.788-.122-1.829-.163c-2.357-.2-4.674-.447-6.91-.732l-1.829-.244c-1.436-.2-2.832-.406-4.214-.637l-2.71-.474-1.815-.352c-2.425-.474-4.742-1-6.923-1.572l-1.355-.352-.542-.149c-.989-.271-1.951-.569-2.886-.854-1.355-.461-2.71-.921-4.065-1.355l-1.829-.732a42.389,42.389,0,0,1-6.137-3.116l-.786-.515-.908-.65c-.325-.23-.623-.474-.908-.718-2.71-2.195-4.065-4.579-4.065-7.059V309.88H360.2v14.592Z",
    transform: "translate(50.698 75.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M233.366,309.874v23.032l-.908-.65c-.325-.23-.623-.474-.908-.718V309.86Z",
    transform: "translate(51.787 75.233)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M239.829,309.86v27.409L238,336.537V309.874Z",
    transform: "translate(54.076 75.233)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M246.3,309.85v30.186l-1.355-.352-.542-.149V309.864Z",
    transform: "translate(56.347 75.229)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M252.726,309.84v32.124l-1.815-.352V309.854Z",
    transform: "translate(58.657 75.226)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M259.189,309.83v33.492l-1.829-.244V309.844Z",
    transform: "translate(60.946 75.222)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M265.639,309.83v34.386l-1.829-.163V309.83Z",
    transform: "translate(63.235 75.222)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M272.086,309.82v34.888l-1.816-.068V309.82Z",
    transform: "translate(65.528 75.219)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M278.549,309.81v35.036H276.72V309.81Z",
    transform: "translate(67.816 75.215)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M285,309.8v34.82l-1.829.081V309.8Z",
    transform: "translate(70.105 75.211)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M291.475,309.79v34.224c-.6.068-1.206.108-1.815.163V309.79Z",
    transform: "translate(72.408 75.208)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M297.909,309.78v33.235l-1.829.244V309.78Z",
    transform: "translate(74.686 75.204)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M304.359,309.77v31.744l-1.829.366V309.77Z",
    transform: "translate(76.975 75.201)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M310.815,309.76v29.631l-1.815.5V309.76Z",
    transform: "translate(79.271 75.197)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M317.269,309.75v26.569c-.6.257-1.206.5-1.829.745V309.75Z",
    transform: "translate(81.556 75.194)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M323.719,309.74v21.312a17.275,17.275,0,0,1-1.829,1.463V309.74Z",
    transform: "translate(83.845 75.19)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "y",
    d: "M360.3,314.771c0,10.324-29.5,18.7-65.873,18.7-4.972,0-9.809-.149-14.47-.447-5.853-.366-11.422-.962-16.57-1.748-4.593-.7-8.861-1.545-12.736-2.52q-1.775-.447-3.414-.935a54.627,54.627,0,0,1-11.99-4.837c-.61-.339-1.179-.7-1.694-1.057-3.225-2.208-5-4.62-5-7.154a4.226,4.226,0,0,1,0-.7c1.274-10,30.254-18.006,65.819-18.006a217.492,217.492,0,0,1,24.74,1.355c1.477.163,2.926.352,4.349.555a135.055,135.055,0,0,1,16.8,3.428c1.084.3,2.127.61,3.143.935a54.451,54.451,0,0,1,9.226,3.739,19.919,19.919,0,0,1,5.921,4.485,7.209,7.209,0,0,1,1.68,3.577A4.257,4.257,0,0,1,360.3,314.771Z",
    transform: "translate(50.719 70.336)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ak",
    d: "M349.431,307.885,270.85,330.416c-5.853-.366-11.421-.962-16.57-1.748L343.538,303.4A19.917,19.917,0,0,1,349.431,307.885Z",
    transform: "translate(59.853 72.94)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ak",
    d: "M322.2,297.626l-88.269,25c-.61-.339-1.179-.7-1.694-1.057l85.613-24.5C319.33,297.233,320.78,297.422,322.2,297.626Z",
    transform: "translate(52.032 70.694)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ak",
    d: "M338.521,300.867l-92.767,26.487q-1.775-.447-3.414-.935L335.364,300A31.6,31.6,0,0,1,338.521,300.867Z",
    transform: "translate(55.616 71.734)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M343.554,313.773a5.431,5.431,0,0,1,0,.677c-1.274,7.939-24.387,14.267-52.6,14.267s-51.322-6.327-52.6-14.267a5.419,5.419,0,0,1,0-.677c0-8.251,23.615-14.9,52.65-14.9S343.554,305.522,343.554,313.773Z",
    transform: "translate(54.201 71.333)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ab",
    d: "M343.551,314.121c-1.274,7.939-24.387,14.267-52.6,14.267h-1.883a173.948,173.948,0,0,1-17.857-1.084,117.2,117.2,0,0,1-15.066-2.71c-1.124-.284-2.208-.569-3.252-.881a37.26,37.26,0,0,1-11-4.9,13.914,13.914,0,0,1-1.612-1.355,6.314,6.314,0,0,1-1.924-3.387c1.274-7.926,24.387-14.267,52.6-14.267,3.563,0,7.059.108,10.432.3,1.721.095,3.428.23,5.081.366a127.207,127.207,0,0,1,18.291,2.845c1.152.271,2.263.556,3.319.854a45.74,45.74,0,0,1,10.189,4.065,11.164,11.164,0,0,1,4.959,4.756A4.305,4.305,0,0,1,343.551,314.121Z",
    transform: "translate(54.204 71.663)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "z",
    d: "M334.621,310.81l-54.194,15.378A173.955,173.955,0,0,1,262.57,325.1L329.662,306a11.164,11.164,0,0,1,4.959,4.81Z",
    transform: "translate(62.795 73.863)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "z",
    d: "M305.94,300.426l-64.518,18.345a13.9,13.9,0,0,1-1.612-1.355l61.1-17.356C302.58,300.155,304.288,300.29,305.94,300.426Z",
    transform: "translate(54.719 71.755)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "z",
    d: "M324.261,303.284l-71.929,20.431c-1.125-.285-2.208-.569-3.252-.881l71.807-20.4C322.134,302.7,323.2,302.986,324.261,303.284Z",
    transform: "translate(58.008 72.596)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M290.785,320.977v2.534h-11.11V321.14a143.78,143.78,0,0,1-20.255-1.572l5.988-3.848a117.613,117.613,0,0,0,18.209,1.436c5.284,0,7.167-.312,7.167-.854,0-1.965-30.5-.379-30.5-6.219,0-2.534,6.463-4.647,19.388-5.162V302.47h11.11v2.4a129.143,129.143,0,0,1,16,1.355l-5.6,3.739a109.392,109.392,0,0,0-15.364-1.152c-5.419,0-7.167.447-7.167.975,0,1.883,30.5.312,30.5,6.1C309.157,318.268,303.006,320.368,290.785,320.977Z",
    transform: "translate(61.677 72.61)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "y",
    d: "M290.541,320.382v2.479h-11.11V320.49a143.6,143.6,0,0,1-20.241-1.572l5.988-3.848a117.3,117.3,0,0,0,18.142,1.436c5.284,0,7.167-.312,7.167-.854,0-1.965-30.484-.379-30.484-6.219,0-2.534,6.449-4.647,19.374-5.162V301.82h11.11v2.4a129.125,129.125,0,0,1,16,1.355l-5.555,3.78a107.484,107.484,0,0,0-15.364-1.165c-5.419,0-7.167.447-7.167.975,0,1.883,30.5.312,30.5,6.1C308.913,317.672,302.762,319.772,290.541,320.382Z",
    transform: "translate(61.596 72.38)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ab",
    d: "M363.244,308.182v.19a9.009,9.009,0,0,1-3.468,6.53,19.252,19.252,0,0,1-1.829,1.477,37.394,37.394,0,0,1-6.91,3.794c-.6.257-1.206.515-1.829.759-2.114.826-4.417,1.612-6.91,2.33l-1.829.5c-2.181.583-4.5,1.125-6.923,1.626l-1.829.352q-3.333.637-6.91,1.138l-1.829.244c-2.249.3-4.552.555-6.923.772l-1.816.149c-2.263.19-4.579.339-6.923.447l-1.829.081c-2.263.081-4.579.135-6.91.149h-1.829c-2.344,0-4.647,0-6.923-.122l-1.815-.081c-1.734-.068-3.441-.176-5.135-.285l-1.788-.135-1.829-.149c-2.358-.2-4.674-.461-6.91-.745-.623-.081-1.233-.149-1.829-.244-1.436-.19-2.832-.406-4.214-.637-.908-.149-1.816-.3-2.71-.474l-1.815-.352c-2.425-.474-4.742-1-6.923-1.572l-1.287-.339-.542-.163q-1.49-.406-2.886-.854c-1.355-.447-2.71-.921-4.065-1.355-.637-.23-1.246-.474-1.829-.718a43.741,43.741,0,0,1-6.137-3.13c-.271-.163-.528-.339-.786-.515s-.623-.42-.908-.637-.623-.488-.921-.732c-2.628-2.195-4.064-4.579-4.064-7.059V293.78H363.217v14.592Z",
    transform: "translate(51.745 69.527)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M236.289,293.784v23.033c-.312-.2-.623-.42-.908-.637s-.623-.488-.921-.732V293.77Z",
    transform: "translate(52.82 69.523)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M242.749,293.77v27.409c-.637-.23-1.246-.474-1.829-.718V293.77Z",
    transform: "translate(55.113 69.523)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M249.2,293.771V323.9l-1.287-.339-.542-.163V293.73Z",
    transform: "translate(57.401 69.509)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M255.646,293.75v32.11l-1.816-.352V293.75Z",
    transform: "translate(59.694 69.516)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M262.109,293.74v33.478c-.623-.081-1.233-.149-1.829-.244V293.74Z",
    transform: "translate(61.982 69.512)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M268.559,293.73v34.386l-1.829-.149V293.73Z",
    transform: "translate(64.271 69.509)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M275.006,293.72v34.9l-1.816-.081V293.72Z",
    transform: "translate(66.564 69.505)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M281.479,293.71v35.037H279.65V293.71Z",
    transform: "translate(68.856 69.502)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M287.919,293.7v34.82l-1.829.081V293.7Z",
    transform: "translate(71.141 69.498)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M294.366,293.69v34.291l-1.815.149V293.69Z",
    transform: "translate(73.434 69.495)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M300.829,293.68v33.235l-1.829.244V293.68Z",
    transform: "translate(75.722 69.491)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M307.279,293.67v31.758l-1.829.352V293.67Z",
    transform: "translate(78.011 69.488)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M313.739,293.66V323.3l-1.829.5V293.66Z",
    transform: "translate(80.304 69.484)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M320.189,293.65v26.569c-.6.257-1.206.515-1.829.759V293.664Z",
    transform: "translate(82.592 69.481)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M326.639,293.64v21.312a19.272,19.272,0,0,1-1.829,1.477V293.654Z",
    transform: "translate(84.881 69.477)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "y",
    d: "M363.22,298.671c0,10.337-29.5,18.711-65.873,18.711-4.972,0-9.809-.163-14.47-.461-5.853-.366-11.421-.962-16.57-1.748-4.593-.691-8.861-1.545-12.736-2.52q-1.775-.447-3.414-.935a54.665,54.665,0,0,1-11.99-4.823c-.61-.352-1.179-.7-1.707-1.07-3.211-2.208-4.986-4.62-4.986-7.154a3.959,3.959,0,0,1,0-.691c1.274-10.012,30.254-18.02,65.819-18.02a217.512,217.512,0,0,1,24.74,1.355c1.477.176,2.926.352,4.349.555a132.508,132.508,0,0,1,16.76,3.36c1.084.3,2.127.61,3.143.921a54.413,54.413,0,0,1,9.227,3.753,19.468,19.468,0,0,1,5.921,4.484,7.1,7.1,0,0,1,1.68,3.577,3.96,3.96,0,0,1,.108.7Z",
    transform: "translate(51.755 64.622)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ak",
    d: "M352.351,291.795,273.77,314.312c-5.853-.366-11.421-.962-16.57-1.748l89.258-25.255a19.47,19.47,0,0,1,5.894,4.484Z",
    transform: "translate(60.89 67.231)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ak",
    d: "M325.126,281.515l-88.269,25.011c-.61-.352-1.179-.7-1.707-1.07L320.777,281C322.254,281.135,323.7,281.312,325.126,281.515Z",
    transform: "translate(53.065 64.992)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ak",
    d: "M341.441,284.781l-92.767,26.487q-1.775-.447-3.414-.935L338.3,283.86C339.382,284.158,340.425,284.47,341.441,284.781Z",
    transform: "translate(56.653 66.007)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M346.554,297.673a5.924,5.924,0,0,1,0,.691c-1.273,7.926-24.387,14.267-52.6,14.267s-51.322-6.341-52.6-14.267a5.944,5.944,0,0,1,0-.691c0-8.238,23.615-14.9,52.65-14.9S346.554,289.436,346.554,297.673Z",
    transform: "translate(55.266 65.62)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ab",
    d: "M346.461,298.027c-1.274,7.926-24.387,14.267-52.6,14.267h-1.883a173.722,173.722,0,0,1-17.857-1.084,117.182,117.182,0,0,1-15.066-2.71c-1.125-.271-2.208-.569-3.252-.881a36.919,36.919,0,0,1-11-4.9,12.676,12.676,0,0,1-1.612-1.355,6.232,6.232,0,0,1-1.924-3.374c1.274-7.926,24.387-14.267,52.6-14.267,3.563,0,7.059.095,10.432.3,1.721.095,3.428.217,5.081.366a129.542,129.542,0,0,1,18.291,2.832c1.152.271,2.263.555,3.319.867a44.456,44.456,0,0,1,10.188,4.065,11.286,11.286,0,0,1,4.959,4.742A4.254,4.254,0,0,1,346.461,298.027Z",
    transform: "translate(55.237 65.957)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "z",
    d: "M337.541,294.674l-54.194,15.378a173.712,173.712,0,0,1-17.857-1.084L332.569,290a11.286,11.286,0,0,1,4.972,4.674Z",
    transform: "translate(63.831 68.185)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "z",
    d: "M308.875,284.336,244.3,302.667a12.683,12.683,0,0,1-1.612-1.355l61.1-17.342C305.515,284.011,307.222,284.187,308.875,284.336Z",
    transform: "translate(55.741 66.046)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "z",
    d: "M327.181,287.252l-71.929,20.323c-1.125-.271-2.208-.569-3.252-.881l71.807-20.4C325.013,286.615,326.124,286.9,327.181,287.252Z",
    transform: "translate(59.044 66.869)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M293.723,304.858v2.493h-11.11V304.98a145.883,145.883,0,0,1-20.323-1.572l5.988-3.848a119.355,119.355,0,0,0,18.209,1.423c5.284,0,7.167-.312,7.167-.84,0-1.978-30.5-.379-30.5-6.219,0-2.534,6.463-4.661,19.388-5.175V286.31h11.11v2.4a129.572,129.572,0,0,1,16,1.287l-5.6,3.834a107.471,107.471,0,0,0-15.364-1.165c-5.419,0-7.167.447-7.167.989,0,1.87,30.5.312,30.5,6.083C312.094,302.148,305.944,304.3,293.723,304.858Z",
    transform: "translate(62.696 66.876)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "y",
    d: "M293.461,304.278v2.493h-11.11V304.4a145.645,145.645,0,0,1-20.241-1.572l5.988-3.848a118.969,118.969,0,0,0,18.25,1.436c5.284,0,7.167-.325,7.167-.854,0-1.978-30.484-.379-30.484-6.219,0-2.534,6.449-4.661,19.374-5.176V285.73h11.11v2.4a129.294,129.294,0,0,1,16,1.287l-5.6,3.834a107.474,107.474,0,0,0-15.364-1.165c-5.419,0-7.167.447-7.167.989,0,1.87,30.5.312,30.5,6.083C311.833,301.568,305.682,303.709,293.461,304.278Z",
    transform: "translate(62.632 66.67)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ab",
    d: "M360.22,293.042v.19a9.01,9.01,0,0,1-3.469,6.53,19.225,19.225,0,0,1-1.829,1.477,37.388,37.388,0,0,1-6.91,3.794c-.6.257-1.206.515-1.829.759-2.114.826-4.417,1.612-6.91,2.33l-1.829.5c-2.181.582-4.5,1.124-6.923,1.612-.6.135-1.206.244-1.829.366q-3.333.637-6.91,1.138l-1.829.244c-2.249.3-4.552.555-6.923.772l-1.816.149c-2.263.19-4.579.339-6.923.447l-1.829.081c-2.263.081-4.579.135-6.91.149h-1.829c-2.344,0-4.647,0-6.923-.122l-1.815-.081c-1.734,0-3.441-.176-5.135-.285l-1.788-.135-1.829-.149c-2.357-.217-4.674-.461-6.91-.745l-1.829-.244c-1.436-.19-2.832-.406-4.214-.637l-2.71-.474-1.816-.352c-2.425-.474-4.742-1-6.923-1.572l-1.287-.339-.542-.163q-1.477-.406-2.886-.854c-1.355-.447-2.71-.921-4.065-1.355-.637-.23-1.233-.474-1.829-.718a43.744,43.744,0,0,1-6.137-3.13c-.271-.163-.528-.339-.786-.515a11,11,0,0,1-.908-.65c-.325-.23-.623-.474-.908-.718-2.642-2.195-4.065-4.579-4.065-7.059V278.64H360.139v14.592Z",
    transform: "translate(50.677 64.154)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M233.266,278.644v23.033a10.972,10.972,0,0,1-.908-.65c-.325-.23-.623-.474-.908-.718V278.63Z",
    transform: "translate(51.752 64.151)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M239.729,278.63v27.4c-.637-.23-1.233-.474-1.829-.718V278.63Z",
    transform: "translate(54.041 64.151)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M246.179,278.62v30.173l-1.287-.339-.542-.163V278.62Z",
    transform: "translate(56.33 64.147)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M252.626,278.61v32.11l-1.815-.352V278.61Z",
    transform: "translate(58.622 64.144)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M259.089,278.6v33.479l-1.829-.244V278.6Z",
    transform: "translate(60.911 64.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M265.539,278.59v34.427l-1.829-.149V278.59Z",
    transform: "translate(63.2 64.136)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M271.986,278.58v34.9l-1.816-.081V278.58Z",
    transform: "translate(65.492 64.133)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M278.479,278.57v35.036H276.65V278.57Z",
    transform: "translate(67.791 64.129)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M284.9,278.56v34.82l-1.829.081v-34.9Z",
    transform: "translate(70.07 64.126)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M291.346,278.55v34.237l-1.815.149V278.55Z",
    transform: "translate(72.362 64.122)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M297.809,278.54v33.235l-1.829.244V278.54Z",
    transform: "translate(74.651 64.119)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M304.259,278.53v31.8c-.6.136-1.206.244-1.829.366v-32.11Z",
    transform: "translate(76.94 64.115)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M310.719,278.52v29.644l-1.829.5V278.52Z",
    transform: "translate(79.232 64.112)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M317.169,278.51v26.569c-.6.257-1.206.515-1.829.759V278.51Z",
    transform: "translate(81.521 64.108)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M323.619,278.5v21.312a19.253,19.253,0,0,1-1.829,1.477V278.5Z",
    transform: "translate(83.81 64.104)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "y",
    d: "M360.2,283.531c0,10.338-29.5,18.711-65.873,18.711-4.972,0-9.809-.163-14.47-.461-5.853-.366-11.421-.962-16.57-1.748-4.593-.691-8.861-1.545-12.736-2.52q-1.775-.447-3.414-.935a54.663,54.663,0,0,1-11.991-4.823c-.61-.352-1.179-.7-1.694-1.07-3.225-2.208-5-4.62-5-7.154a3.961,3.961,0,0,1,0-.691c1.274-10.012,30.254-18.02,65.819-18.02a217.478,217.478,0,0,1,24.74,1.355c1.477.176,2.926.352,4.349.555a132.512,132.512,0,0,1,16.76,3.36c1.084.3,2.127.61,3.143.921a54.407,54.407,0,0,1,9.227,3.753,19.471,19.471,0,0,1,5.921,4.485,7.1,7.1,0,0,1,1.68,3.577A3.969,3.969,0,0,1,360.2,283.531Z",
    transform: "translate(50.684 59.25)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ak",
    d: "M349.331,276.655,270.75,299.172c-5.853-.366-11.421-.962-16.57-1.748l89.177-25.254A19.47,19.47,0,0,1,349.331,276.655Z",
    transform: "translate(59.818 61.858)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ak",
    d: "M322.1,266.386,233.834,291.4c-.61-.352-1.179-.7-1.694-1.07l85.613-24.5C319.23,266.06,320.68,266.182,322.1,266.386Z",
    transform: "translate(51.997 59.608)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ak",
    d: "M338.421,269.624l-92.767,26.555q-1.775-.447-3.414-.935l93.038-26.474C336.362,269,337.4,269.312,338.421,269.624Z",
    transform: "translate(55.581 60.652)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M343.484,282.533a5.932,5.932,0,0,1,0,.691c-1.274,7.926-24.387,14.267-52.6,14.267s-51.322-6.341-52.6-14.267a5.945,5.945,0,0,1,0-.691c0-8.237,23.615-14.9,52.65-14.9S343.484,274.3,343.484,282.533Z",
    transform: "translate(54.177 60.247)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ab",
    d: "M343.441,282.887c-1.273,7.926-24.387,14.267-52.6,14.267h-1.883a173.947,173.947,0,0,1-17.857-1.084,117.2,117.2,0,0,1-15.066-2.71c-1.125-.271-2.208-.569-3.252-.881a36.919,36.919,0,0,1-11-4.9,11.642,11.642,0,0,1-1.6-1.355,6.219,6.219,0,0,1-1.937-3.374c1.274-7.926,24.387-14.267,52.6-14.267q5.419,0,10.432.3c1.721.095,3.428.217,5.081.366a127.368,127.368,0,0,1,18.29,2.832c1.152.271,2.263.556,3.319.867a45.134,45.134,0,0,1,10.189,4.065,11.3,11.3,0,0,1,4.959,4.756,4.252,4.252,0,0,1,.325,1.124Z",
    transform: "translate(54.165 60.584)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "z",
    d: "M334.521,279.556l-54.194,15.378a173.956,173.956,0,0,1-17.857-1.084L329.576,274.8A11.3,11.3,0,0,1,334.521,279.556Z",
    transform: "translate(62.76 62.792)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "z",
    d: "M305.851,269.2l-64.572,18.331a11.632,11.632,0,0,1-1.6-1.355l61.09-17.342C302.437,268.925,304.2,269.06,305.851,269.2Z",
    transform: "translate(54.673 60.673)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "z",
    d: "M324.161,272.057l-71.929,20.418c-1.125-.271-2.208-.569-3.252-.881l71.807-20.4C321.993,271.461,323.1,271.745,324.161,272.057Z",
    transform: "translate(57.973 61.511)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M290.685,289.755v2.493h-11.11V289.9a144.09,144.09,0,0,1-20.255-1.558l6-3.848a119.032,119.032,0,0,0,18.2,1.355c5.284,0,7.167-.312,7.167-.84,0-1.978-30.5-.379-30.5-6.232,0-2.52,6.463-4.647,19.388-5.162V271.18h11.11v2.466a129.333,129.333,0,0,1,16,1.287l-5.6,3.834a107.47,107.47,0,0,0-15.364-1.165c-5.419,0-7.167.447-7.167.989,0,1.87,30.5.312,30.5,6.083C309.016,287.045,302.906,289.159,290.685,289.755Z",
    transform: "translate(61.642 61.507)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "y",
    d: "M290.452,289.138v2.493H279.3v-2.385a143.866,143.866,0,0,1-20.241-1.558l5.988-3.848a119.235,119.235,0,0,0,18.2,1.423c5.284,0,7.167-.312,7.167-.84,0-1.978-30.484-.379-30.484-6.232,0-2.52,6.463-4.647,19.374-5.162V270.59h11.11v2.4a129.3,129.3,0,0,1,16,1.287l-5.6,3.834a107.476,107.476,0,0,0-15.364-1.165c-5.419,0-7.167.447-7.167.989,0,1.87,30.5.312,30.5,6.083C308.824,286.428,302.673,288.542,290.452,289.138Z",
    transform: "translate(61.55 61.298)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ab",
    d: "M361.169,276.334v.19a9.064,9.064,0,0,1-3.455,6.53,23.43,23.43,0,0,1-1.829,1.477,37.541,37.541,0,0,1-6.923,3.794c-.583.257-1.192.5-1.829.759-2.1.826-4.417,1.6-6.91,2.317l-1.829.515c-2.181.583-4.5,1.124-6.923,1.612l-1.815.366c-2.222.42-4.539.8-6.923,1.138l-1.829.244c-2.236.3-4.552.556-6.91.772l-1.829.149c-2.263.19-4.566.339-6.923.447l-1.815.081c-2.276.081-4.579.135-6.923.149h-1.829c-2.33,0-4.634,0-6.91-.135l-1.829-.068c-1.734,0-3.441-.176-5.121-.284l-1.8-.136L277.2,296.1c-2.371-.217-4.674-.461-6.923-.745l-1.829-.244c-1.355-.19-2.832-.406-4.2-.637l-2.71-.474-1.829-.352q-3.645-.718-6.923-1.572l-1.274-.352-.542-.149c-.989-.271-1.965-.555-2.886-.854-1.423-.447-2.71-.921-4.065-1.355q-.935-.352-1.829-.732a42.367,42.367,0,0,1-6.137-3.116l-.772-.515-.921-.65c-.312-.23-.623-.474-.908-.718-2.71-2.195-4.065-4.579-4.065-7.059a3.459,3.459,0,0,1,0-.528V262H361.1v14.592Z",
    transform: "translate(51.015 58.249)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M234.229,262v23.033l-.921-.65c-.312-.23-.623-.474-.908-.718V262Z",
    transform: "translate(52.089 58.249)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M240.679,261.94v27.4q-.935-.352-1.829-.732V261.94Z",
    transform: "translate(54.378 58.228)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M247.126,261.93V292.1l-1.274-.352-.542-.149V261.93Z",
    transform: "translate(56.67 58.225)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M253.589,261.92v32.11l-1.829-.352V261.92Z",
    transform: "translate(58.959 58.221)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M260.039,261.91v33.479l-1.829-.244V261.91Z",
    transform: "translate(61.248 58.217)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M266.475,261.9v34.386l-1.815-.149V261.9Z",
    transform: "translate(63.537 58.214)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M272.949,261.89v34.888l-1.829-.068V261.89Z",
    transform: "translate(65.829 58.21)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M279.4,261.88v35.037H277.57V261.88Z",
    transform: "translate(68.118 58.207)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M285.845,261.87v34.82l-1.815.081v-34.9Z",
    transform: "translate(70.41 58.203)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M292.309,261.86V296.1l-1.829.149V261.86Z",
    transform: "translate(72.699 58.2)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M298.759,261.85v33.235l-1.829.244V261.85Z",
    transform: "translate(74.988 58.196)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M305.206,261.84v31.744l-1.815.366V261.84Z",
    transform: "translate(77.28 58.193)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M311.669,261.83v29.631l-1.829.515V261.83Z",
    transform: "translate(79.569 58.189)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M318.119,261.82v26.569c-.583.257-1.192.5-1.829.759V261.82Z",
    transform: "translate(81.858 58.186)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M324.579,261.81v21.312a23.375,23.375,0,0,1-1.829,1.477V261.81Z",
    transform: "translate(84.15 58.182)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "y",
    d: "M361.149,266.841c0,10.324-29.482,18.711-65.873,18.711-4.972,0-9.809-.163-14.47-.461-5.853-.366-11.408-.962-16.556-1.748-4.607-.691-8.874-1.545-12.736-2.52-1.179-.3-2.33-.61-3.428-.935a54.935,54.935,0,0,1-11.99-4.823c-.61-.352-1.165-.7-1.694-1.07-3.224-2.208-5-4.62-5-7.154a5.946,5.946,0,0,1,0-.691c1.287-10.012,30.268-18.02,65.819-18.02a217.338,217.338,0,0,1,24.74,1.355c1.477.162,2.926.352,4.349.555a133.2,133.2,0,0,1,16.827,3.333c1.07.3,2.127.6,3.13.921a55.115,55.115,0,0,1,9.227,3.739,19.7,19.7,0,0,1,5.921,4.5,6.883,6.883,0,0,1,1.68,3.577,3.965,3.965,0,0,1,.054.732Z",
    transform: "translate(51.022 53.327)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ak",
    d: "M350.278,259.968,271.7,282.486c-5.853-.366-11.408-.962-16.556-1.748l89.231-25.268A19.7,19.7,0,0,1,350.278,259.968Z",
    transform: "translate(60.159 55.932)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ak",
    d: "M323.052,249.7l-88.269,25c-.61-.352-1.165-.7-1.694-1.07l85.613-24.5Q320.918,249.394,323.052,249.7Z",
    transform: "translate(52.334 53.682)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ak",
    d: "M339.371,252.962l-92.753,26.487c-1.179-.3-2.33-.61-3.428-.935L336.241,252C337.312,252.339,338.369,252.637,339.371,252.962Z",
    transform: "translate(55.918 54.701)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M344.434,265.843a3.954,3.954,0,0,1,0,.691c-1.26,7.926-24.387,14.267-52.6,14.267s-51.322-6.341-52.6-14.267a5.92,5.92,0,0,1,0-.691c0-8.251,23.629-14.9,52.65-14.9S344.434,257.592,344.434,265.843Z",
    transform: "translate(54.514 54.325)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ab",
    d: "M344.391,266.2c-1.26,7.926-24.387,14.267-52.6,14.267h-1.87a174.169,174.169,0,0,1-17.871-1.084,117.627,117.627,0,0,1-15.066-2.71c-1.111-.271-2.195-.569-3.238-.881a37.368,37.368,0,0,1-11.015-4.9,11.639,11.639,0,0,1-1.6-1.355,6.3,6.3,0,0,1-1.937-3.374c1.274-7.926,24.387-14.267,52.6-14.267q5.419,0,10.446.285c1.721.108,3.414.23,5.067.379a125.425,125.425,0,0,1,18.331,2.872c1.152.271,2.263.556,3.333.867a45.378,45.378,0,0,1,10.189,4.065,11.327,11.327,0,0,1,4.945,4.755,4.257,4.257,0,0,1,.284,1.084Z",
    transform: "translate(54.502 54.662)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "z",
    d: "M335.475,262.866l-54.194,15.378a174.179,174.179,0,0,1-17.871-1.084L330.6,258.11a11.326,11.326,0,0,1,4.877,4.756Z",
    transform: "translate(63.093 56.869)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "z",
    d: "M306.8,252.509l-64.572,18.331a11.647,11.647,0,0,1-1.6-1.355l61.1-17.356C303.455,252.238,305.148,252.36,306.8,252.509Z",
    transform: "translate(55.01 54.747)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "z",
    d: "M325.121,255.367l-71.943,20.418c-1.111-.271-2.195-.569-3.238-.881l71.807-20.4C322.94,254.771,324.051,255.055,325.121,255.367Z",
    transform: "translate(58.313 55.588)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M291.663,273.086v2.439h-11.11v-2.371A146.015,146.015,0,0,1,260.23,271.6l5.989-3.848a119.323,119.323,0,0,0,18.2,1.355c5.284,0,7.181-.312,7.181-.84,0-1.978-30.5-.393-30.5-6.232,0-2.52,6.463-4.647,19.388-5.162V254.43h11.11v2.385a129.1,129.1,0,0,1,15.987,1.355l-5.6,3.834a107.473,107.473,0,0,0-15.364-1.165c-5.419,0-7.167.447-7.167.989,0,1.87,30.5.312,30.5,6.083C310.048,270.377,303.87,272.477,291.663,273.086Z",
    transform: "translate(61.965 55.563)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "y",
    d: "M291.419,272.448v2.479h-11.1v-2.371A145.983,145.983,0,0,1,260,271l5.988-3.848a119.36,119.36,0,0,0,18.209,1.423c5.27,0,7.167-.312,7.167-.84,0-1.978-30.5-.393-30.5-6.232,0-2.52,6.463-4.647,19.388-5.162V253.9h11.11v2.385a129.6,129.6,0,0,1,16,1.355l-5.6,3.834a107.81,107.81,0,0,0-15.378-1.165c-5.419,0-7.167.447-7.167.989,0,1.87,30.5.312,30.5,6.083C309.777,269.738,303.626,271.838,291.419,272.448Z",
    transform: "translate(61.883 55.375)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ab",
    d: "M359.4,260.2v.19a9.01,9.01,0,0,1-3.468,6.53,20.875,20.875,0,0,1-1.816,1.477,37.537,37.537,0,0,1-6.923,3.794c-.583.257-1.192.515-1.829.759-2.1.826-4.417,1.612-6.91,2.33l-1.829.5c-2.181.583-4.5,1.125-6.923,1.626l-1.815.352c-2.222.42-4.539.8-6.923,1.138l-1.829.257c-2.235.285-4.552.542-6.91.759l-1.829.163c-2.263.176-4.566.325-6.923.434l-1.815.081c-2.276.081-4.579.136-6.923.149h-1.829c-2.33,0-4.647,0-6.91-.122l-1.829-.081q-2.6-.095-5.121-.284l-1.8-.135-1.815-.149c-2.371-.2-4.674-.461-6.923-.745l-1.829-.244c-1.423-.19-2.832-.406-4.2-.637-.921-.149-1.829-.3-2.71-.474l-1.829-.339q-3.631-.732-6.923-1.585l-1.355-.339-.542-.149c-.989-.284-1.951-.569-2.872-.867-1.423-.447-2.71-.921-4.065-1.355l-1.829-.732a42.357,42.357,0,0,1-6.138-3.13c-.271-.163-.528-.339-.772-.515s-.623-.42-.921-.637-.623-.488-.908-.732c-2.71-2.195-4.065-4.579-4.065-7.059V245.8H359.269v14.592Z",
    transform: "translate(50.368 52.501)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M232.479,245.8v23.033c-.325-.2-.623-.42-.921-.637s-.623-.488-.908-.732V245.79Z",
    transform: "translate(51.468 52.497)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M238.9,245.79v27.382l-1.829-.732V245.79Z",
    transform: "translate(53.746 52.497)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M245.367,245.78v30.173l-1.355-.339-.542-.149V245.78Z",
    transform: "translate(56.017 52.494)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M251.809,245.77v32.11l-1.829-.339V245.77Z",
    transform: "translate(58.327 52.49)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M258.259,245.76v33.478l-1.829-.244V245.76Z",
    transform: "translate(60.616 52.487)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M264.706,245.75v34.386l-1.815-.149V245.75Z",
    transform: "translate(62.909 52.483)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M271.169,245.74v34.9l-1.829-.081V245.74Z",
    transform: "translate(65.198 52.479)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M277.619,245.73v35.037H275.79V245.73Z",
    transform: "translate(67.486 52.476)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M284.066,245.72v34.82l-1.815.081v-34.9Z",
    transform: "translate(69.779 52.472)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M290.529,245.71v34.264l-1.829.163V245.71Z",
    transform: "translate(72.067 52.469)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M296.979,245.7v33.235l-1.829.257V245.7Z",
    transform: "translate(74.356 52.465)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M303.476,245.69v31.758l-1.815.352V245.7Z",
    transform: "translate(76.666 52.462)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M309.889,245.68v29.644l-1.829.5V245.694Z",
    transform: "translate(78.937 52.458)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M316.339,245.67v26.569c-.583.257-1.192.515-1.829.759V245.684Z",
    transform: "translate(81.226 52.455)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M322.785,245.67v21.3a20.9,20.9,0,0,1-1.815,1.477V245.67Z",
    transform: "translate(83.519 52.455)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "y",
    d: "M359.369,250.691c0,10.338-29.482,18.71-65.873,18.71-4.972,0-9.809-.163-14.47-.447-5.853-.379-11.408-.975-16.556-1.761-4.607-.691-8.874-1.545-12.736-2.52-1.179-.3-2.33-.61-3.428-.935a54.667,54.667,0,0,1-11.99-4.823c-.61-.352-1.179-.7-1.694-1.07-3.225-2.195-5-4.62-5-7.154a5.919,5.919,0,0,1,0-.691c1.355-10.012,30.267-18.02,65.819-18.02a217.506,217.506,0,0,1,24.74,1.355c1.477.176,2.926.352,4.349.555a132.5,132.5,0,0,1,16.76,3.36c1.084.3,2.141.61,3.143.921a55.074,55.074,0,0,1,9.227,3.753,19.469,19.469,0,0,1,5.921,4.485,6.991,6.991,0,0,1,1.68,3.577,3.954,3.954,0,0,1,.108.7Z",
    transform: "translate(50.39 47.597)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ak",
    d: "M348.5,243.815l-78.582,22.531c-5.853-.379-11.408-.975-16.556-1.761L342.6,239.33A19.471,19.471,0,0,1,348.5,243.815Z",
    transform: "translate(59.527 50.205)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ak",
    d: "M321.272,233.542,233,258.553c-.61-.352-1.179-.7-1.694-1.07L316.923,233C318.4,233.163,319.85,233.339,321.272,233.542Z",
    transform: "translate(51.702 47.959)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ak",
    d: "M337.591,236.8l-92.753,26.487c-1.179-.3-2.33-.61-3.428-.935l93.038-26.474C335.532,236.178,336.589,236.49,337.591,236.8Z",
    transform: "translate(55.286 48.981)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M342.654,249.693a5.971,5.971,0,0,1,0,.691c-1.26,7.926-24.387,14.267-52.6,14.267s-51.322-6.341-52.6-14.267a5.914,5.914,0,0,1,0-.691c0-8.237,23.629-14.9,52.65-14.9S342.654,241.456,342.654,249.693Z",
    transform: "translate(53.882 48.594)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ab",
    d: "M342.611,250.037c-1.26,7.926-24.387,14.267-52.6,14.267h-1.883a170.48,170.48,0,0,1-17.857-1.084,117.756,117.756,0,0,1-15.066-2.642c-1.124-.285-2.195-.583-3.238-.894a37.017,37.017,0,0,1-11.015-4.9,12.636,12.636,0,0,1-1.6-1.355,6.34,6.34,0,0,1-1.937-3.387c1.274-7.926,24.387-14.267,52.6-14.267q5.419,0,10.446.3c1.721.095,3.414.217,5.067.366a129.241,129.241,0,0,1,18.291,2.832c1.152.271,2.263.556,3.319.867a44.844,44.844,0,0,1,10.189,4.064,11.219,11.219,0,0,1,4.959,4.742A4.257,4.257,0,0,1,342.611,250.037Z",
    transform: "translate(53.87 48.942)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "z",
    d: "M333.691,246.694,279.5,262.072a170.448,170.448,0,0,1-17.857-1.084l67.052-18.968A11.218,11.218,0,0,1,333.691,246.694Z",
    transform: "translate(62.465 51.159)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "z",
    d: "M305.032,236.352l-64.613,18.331a12.643,12.643,0,0,1-1.6-1.355L300.032,236C301.685,236.081,303.379,236.2,305.032,236.352Z",
    transform: "translate(54.367 49.023)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "z",
    d: "M323.327,239.227,251.4,259.658c-1.125-.284-2.195-.583-3.238-.894l71.807-20.4C321.105,238.617,322.271,238.9,323.327,239.227Z",
    transform: "translate(57.682 49.861)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M289.865,256.9v2.493h-11.11v-2.371a145.691,145.691,0,0,1-20.255-1.545l5.988-3.848a119.116,119.116,0,0,0,18.2,1.436c5.284,0,7.181-.325,7.181-.854,0-1.978-30.5-.379-30.5-6.219,0-2.534,6.463-4.661,19.388-5.176V238.38h11.11v2.4a126.534,126.534,0,0,1,15.987,1.355l-5.6,3.821a107.474,107.474,0,0,0-15.364-1.165c-5.419,0-7.167.447-7.167.989,0,1.883,30.5.312,30.5,6.083C308.223,254.191,302.072,256.3,289.865,256.9Z",
    transform: "translate(61.351 49.868)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "y",
    d: "M289.625,256.3v2.493h-11.11V256.42a145.69,145.69,0,0,1-20.255-1.572L264.249,251a119.22,119.22,0,0,0,18.2,1.436c5.284,0,7.181-.325,7.181-.854,0-1.978-30.5-.379-30.5-6.219,0-2.534,6.463-4.661,19.388-5.176V237.75h11.11v2.4a126.538,126.538,0,0,1,15.987,1.355l-5.6,3.821a107.488,107.488,0,0,0-15.364-1.165c-5.419,0-7.167.447-7.167.989,0,1.883,30.5.312,30.5,6.083C308.037,253.588,301.832,255.7,289.625,256.3Z",
    transform: "translate(61.266 49.644)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ab",
    d: "M361.37,244.512v.19a9.01,9.01,0,0,1-3.468,6.53,19.247,19.247,0,0,1-1.829,1.477,37.384,37.384,0,0,1-6.91,3.794c-.6.257-1.206.515-1.829.759-2.114.826-4.417,1.612-6.91,2.33l-1.829.5c-2.181.583-4.5,1.125-6.923,1.626l-1.829.352q-3.333.637-6.91,1.138l-1.829.244c-2.249.3-4.552.556-6.923.772l-1.815.149c-2.263.19-4.579.339-6.923.447l-1.829.081c-2.263.081-4.579.135-6.91.149h-1.829c-2.344,0-4.647,0-6.923-.122l-1.816-.081c-1.734-.068-3.441-.176-5.135-.285l-1.788-.135-1.829-.149c-2.357-.2-4.674-.461-6.91-.745-.623-.081-1.233-.149-1.829-.244-1.436-.19-2.832-.406-4.214-.637-.908-.149-1.815-.3-2.71-.474l-1.816-.352c-2.425-.474-4.742-1-6.923-1.572l-1.287-.339-.542-.163q-1.477-.406-2.886-.854c-1.355-.447-2.71-.921-4.065-1.355-.637-.23-1.247-.474-1.829-.718a43.742,43.742,0,0,1-6.138-3.13c-.271-.163-.528-.339-.786-.515s-.623-.42-.908-.637-.623-.488-.908-.732c-2.642-2.195-4.065-4.579-4.065-7.059V230.11H361.289V244.7Z",
    transform: "translate(51.085 46.933)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M234.416,230.114v23.033c-.312-.2-.623-.42-.908-.637s-.623-.488-.908-.732V230.1Z",
    transform: "translate(52.16 46.93)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M240.879,230.1v27.4c-.637-.23-1.246-.474-1.829-.718V230.1Z",
    transform: "translate(54.449 46.93)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M247.329,230.09v30.173l-1.287-.339-.542-.163V230.09Z",
    transform: "translate(56.738 46.926)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M253.776,230.08v32.11l-1.815-.352V230.08Z",
    transform: "translate(59.03 46.922)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M260.239,230.07v33.478c-.623-.081-1.233-.149-1.829-.244V230.07Z",
    transform: "translate(61.319 46.919)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M266.689,230.06v34.386l-1.829-.149V230.06Z",
    transform: "translate(63.608 46.915)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M273.136,230.05v34.9l-1.816-.081V230.05Z",
    transform: "translate(65.9 46.912)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M279.6,230v35.091H277.77V230Z",
    transform: "translate(68.189 46.894)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M286.049,230v34.82l-1.829.081V230Z",
    transform: "translate(70.478 46.894)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M292.476,230v34.237l-1.816.149V230Z",
    transform: "translate(72.763 46.894)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M298.959,230v33.235l-1.829.244V230Z",
    transform: "translate(75.059 46.894)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M305.409,230v31.758l-1.829.352V230Z",
    transform: "translate(77.348 46.894)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M311.869,230v29.644l-1.829.5V230Z",
    transform: "translate(79.64 46.894)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M318.319,230v26.569c-.6.257-1.206.515-1.829.759V230Z",
    transform: "translate(81.929 46.894)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M324.769,230v21.271a19.24,19.24,0,0,1-1.829,1.477V230Z",
    transform: "translate(84.218 46.894)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "y",
    d: "M361.35,235c0,10.338-29.5,18.711-65.873,18.711-4.972,0-9.809-.163-14.47-.461-5.853-.366-11.421-.962-16.57-1.748-4.593-.691-8.861-1.545-12.736-2.52q-1.775-.447-3.414-.935a54.672,54.672,0,0,1-11.99-4.823c-.61-.352-1.179-.7-1.707-1.07-3.211-2.195-4.986-4.62-4.986-7.154a3.946,3.946,0,0,1,0-.691c1.274-10.012,30.254-18.02,65.819-18.02a217.487,217.487,0,0,1,24.74,1.355c1.477.176,2.926.352,4.349.555a132.494,132.494,0,0,1,16.76,3.36c1.084.3,2.127.61,3.143.921a55.546,55.546,0,0,1,9.227,3.753,19.467,19.467,0,0,1,5.921,4.485,7.1,7.1,0,0,1,1.68,3.577A3.952,3.952,0,0,1,361.35,235Z",
    transform: "translate(51.092 42.029)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ak",
    d: "M350.481,228.175,271.9,250.692c-5.853-.366-11.421-.962-16.57-1.748l89.258-25.254A19.47,19.47,0,0,1,350.481,228.175Z",
    transform: "translate(60.226 44.655)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ak",
    d: "M323.256,217.855l-88.269,25.011c-.61-.352-1.179-.7-1.707-1.07l85.627-24.5C320.384,217.476,321.833,217.652,323.256,217.855Z",
    transform: "translate(52.401 42.387)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ak",
    d: "M339.571,221.111,246.8,247.6q-1.775-.447-3.414-.935l93.038-26.474C337.512,220.488,338.555,220.8,339.571,221.111Z",
    transform: "translate(55.989 43.413)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M344.634,234a5.93,5.93,0,0,1,0,.691c-1.274,7.926-24.387,14.267-52.6,14.267s-51.322-6.341-52.6-14.267a5.918,5.918,0,0,1,0-.691c0-8.237,23.615-14.9,52.65-14.9S344.634,225.739,344.634,234Z",
    transform: "translate(54.585 43.026)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ab",
    d: "M344.54,234.347c-1.274,7.926-24.387,14.267-52.6,14.267h-1.883a173.976,173.976,0,0,1-17.857-1.084,119.736,119.736,0,0,1-15.066-2.71q-1.694-.42-3.252-.894a36.921,36.921,0,0,1-10.961-4.85,12.678,12.678,0,0,1-1.612-1.355,6.232,6.232,0,0,1-1.924-3.374c1.273-7.926,24.387-14.267,52.6-14.267,3.563,0,7.059.095,10.432.3,1.721.095,3.428.217,5.081.366a129.241,129.241,0,0,1,18.291,2.832c1.152.271,2.263.556,3.32.867a45.1,45.1,0,0,1,10.188,4.065,11.286,11.286,0,0,1,4.959,4.742A4.26,4.26,0,0,1,344.54,234.347Z",
    transform: "translate(54.57 43.374)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "z",
    d: "M335.671,231.022,281.477,246.4a173.983,173.983,0,0,1-17.857-1.084l67.052-19.036a11.286,11.286,0,0,1,5,4.742Z",
    transform: "translate(63.168 45.574)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "z",
    d: "M307.008,220.666,242.422,239a12.685,12.685,0,0,1-1.612-1.355l61.1-17.342C303.648,220.395,305.355,220.517,307.008,220.666Z",
    transform: "translate(55.073 43.452)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "z",
    d: "M325.311,223.527l-71.929,20.431q-1.694-.42-3.252-.894l71.807-20.4C323.116,222.931,324.254,223.215,325.311,223.527Z",
    transform: "translate(58.381 44.289)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M291.835,241.218v2.493h-11.11V241.34a145.872,145.872,0,0,1-20.255-1.572l5.988-3.848a119.3,119.3,0,0,0,18.209,1.436c5.284,0,7.167-.325,7.167-.854,0-1.978-30.5-.379-30.5-6.219,0-2.534,6.463-4.661,19.388-5.176V222.67h11.11v2.4a129.324,129.324,0,0,1,16,1.287l-5.6,3.834a107.475,107.475,0,0,0-15.364-1.165c-5.419,0-7.167.447-7.167.989,0,1.87,30.5.312,30.5,6.083C310.207,238.508,304.056,240.622,291.835,241.218Z",
    transform: "translate(62.05 44.293)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "y",
    d: "M291.591,240.608V243.1h-11.11V240.73a145.674,145.674,0,0,1-20.242-1.572l5.988-3.848a118.964,118.964,0,0,0,18.2,1.436c5.284,0,7.167-.325,7.167-.854,0-1.978-30.484-.379-30.484-6.219,0-2.534,6.449-4.661,19.374-5.176V222.06h11.11v2.4a129.333,129.333,0,0,1,16,1.287l-5.6,3.834a107.471,107.471,0,0,0-15.364-1.165c-5.419,0-7.167.447-7.167.989,0,1.87,30.5.312,30.5,6.083C309.963,237.9,303.812,240.012,291.591,240.608Z",
    transform: "translate(61.968 44.076)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ab",
    d: "M408.877,394.684v.176a8.617,8.617,0,0,1-3.292,6.205,21.341,21.341,0,0,1-1.748,1.355,35.055,35.055,0,0,1-6.571,3.6c-.569.244-1.138.488-1.734.718-2.019.8-4.214,1.531-6.585,2.222l-1.734.474c-2.073.556-4.281,1.07-6.585,1.545l-1.734.339c-2.114.406-4.308.759-6.585,1.084l-1.734.244c-2.127.271-4.322.515-6.571.718l-1.748.149c-2.141.176-4.336.325-6.571.42l-1.734.081c-2.168.081-4.363.122-6.585.135h-1.734q-3.333,0-6.585-.122l-1.734-.068c-1.639-.068-3.265-.163-4.878-.271l-1.707-.122-1.734-.054c-2.249-.2-4.444-.434-6.571-.7l-1.748-.23c-1.355-.19-2.71-.393-4-.61-.867-.135-1.734-.284-2.574-.447l-1.734-.339c-2.3-.447-4.512-.948-6.585-1.49l-1.219-.325-.515-.149c-.948-.258-1.856-.542-2.71-.813-1.355-.434-2.615-.881-3.834-1.355l-1.734-.691a41.028,41.028,0,0,1-5.839-2.967l-.745-.488-.867-.623c-.3-.217-.583-.447-.867-.677-2.506-2.1-3.875-4.363-3.875-6.774V381H408.8v13.887Z",
    transform: "translate(70.251 100.477)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M288.144,381v21.908l-.867-.623c-.3-.217-.583-.447-.867-.677V381Z",
    transform: "translate(71.255 100.477)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M294.284,381v26.067l-1.734-.691V381Z",
    transform: "translate(73.434 100.477)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M300.454,381v28.709l-1.219-.325-.515-.149V381Z",
    transform: "translate(75.623 100.477)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M306.564,381v30.484l-1.734-.339V381Z",
    transform: "translate(77.791 100.477)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M312.708,381v31.839l-1.748-.23V381Z",
    transform: "translate(79.967 100.477)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M318.834,380.94v32.706l-1.734-.108V381.021Z",
    transform: "translate(82.145 100.456)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M324.974,380.93v33.18l-1.734-.068V380.93Z",
    transform: "translate(84.324 100.452)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M331.114,380.92v33.316H329.38V380.92Z",
    transform: "translate(86.503 100.449)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M337.254,380.91v33.113l-1.734.081V380.91Z",
    transform: "translate(88.682 100.445)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M343.4,380.9v32.517l-1.748.149V380.9Z",
    transform: "translate(90.857 100.442)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M349.524,380.89V412.5l-1.734.244V380.89Z",
    transform: "translate(93.036 100.438)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M355.664,380.88v30.2l-1.734.339V380.88Z",
    transform: "translate(95.215 100.435)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M361.8,380.87v28.194l-1.734.474V380.87Z",
    transform: "translate(97.393 100.431)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M367.944,380.86v25.268c-.569.244-1.138.488-1.734.718V380.874Z",
    transform: "translate(99.572 100.427)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M374.088,380.85v20.323a21.364,21.364,0,0,1-1.748,1.355V380.85Z",
    transform: "translate(101.748 100.424)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "y",
    d: "M408.873,385.656c0,9.823-28.045,17.789-62.648,17.789-4.728,0-9.335-.149-13.765-.434-5.568-.352-10.839-.921-15.757-1.666-4.376-.664-8.441-1.463-12.112-2.4-1.125-.285-2.208-.583-3.265-.881a52.471,52.471,0,0,1-11.394-4.593c-.583-.339-1.111-.677-1.612-1.016-3.062-2.1-4.755-4.4-4.755-6.774a5.271,5.271,0,0,1,0-.664c1.219-9.484,28.777-17.139,62.608-17.139a206.136,206.136,0,0,1,23.52,1.355c1.355.163,2.791.339,4.132.528a126.315,126.315,0,0,1,16.014,3.089c1.03.284,2.032.569,2.994.881a51.01,51.01,0,0,1,8.779,3.563,18.59,18.59,0,0,1,5.623,4.268,6.693,6.693,0,0,1,1.6,3.4,3.565,3.565,0,0,1,.041.691Z",
    transform: "translate(70.241 95.821)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ak",
    d: "M398.538,379.118l-74.761,21.42c-5.568-.352-10.839-.921-15.757-1.666l84.9-24.022a18.587,18.587,0,0,1,5.623,4.268Z",
    transform: "translate(78.923 98.295)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ak",
    d: "M372.643,369.328l-84,23.791c-.583-.339-1.111-.677-1.612-1.016l81.427-23.3C369.92,368.963,371.3,369.139,372.643,369.328Z",
    transform: "translate(71.475 96.148)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ak",
    d: "M388.163,372.431l-88.228,25.187c-1.125-.285-2.208-.583-3.265-.881l88.513-25.187C386.2,371.835,387.2,372.16,388.163,372.431Z",
    transform: "translate(74.896 97.124)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M392.979,384.726a5.278,5.278,0,0,1,0,.65c-1.206,7.533-23.182,13.549-50.021,13.549s-48.775-6.029-50.035-13.549a5.23,5.23,0,0,1,0-.65c0-7.845,22.463-14.226,50.13-14.226S392.979,376.854,392.979,384.726Z",
    transform: "translate(73.562 96.751)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ab",
    d: "M392.936,385.012c-1.206,7.533-23.182,13.548-50.021,13.548h-1.788a165.661,165.661,0,0,1-17-1.03,115.325,115.325,0,0,1-14.321-2.52c-1.07-.271-2.086-.555-3.089-.853A35.335,35.335,0,0,1,296.24,389.5a13.449,13.449,0,0,1-1.517-1.287A6.056,6.056,0,0,1,292.88,385c1.219-7.547,23.182-13.549,50.035-13.549,3.387,0,6.706.095,9.918.285,1.639.095,3.252.217,4.837.352a122.335,122.335,0,0,1,17.4,2.71c1.084.258,2.141.529,3.157.813a42.809,42.809,0,0,1,9.687,3.848,10.7,10.7,0,0,1,4.715,4.512A4.39,4.39,0,0,1,392.936,385.012Z",
    transform: "translate(73.551 97.088)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "z",
    d: "M384.438,381.852l-51.485,14.632a165.728,165.728,0,0,1-17-1.03L379.7,377.34A10.7,10.7,0,0,1,384.438,381.852Z",
    transform: "translate(81.737 99.178)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "z",
    d: "M357.187,372l-61.429,17.437a13.451,13.451,0,0,1-1.517-1.287l58.11-16.5C353.989,371.745,355.6,371.867,357.187,372Z",
    transform: "translate(74.033 97.159)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "z",
    d: "M374.6,374.713l-68.42,19.442c-1.07-.271-2.086-.556-3.089-.854l68.352-19.4C372.526,374.157,373.583,374.428,374.6,374.713Z",
    transform: "translate(77.174 97.958)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M342.814,391.554v2.371H332.246v-2.276a137.584,137.584,0,0,1-19.266-1.49l5.69-3.658a113.211,113.211,0,0,0,17.315,1.355c5.027,0,6.774-.3,6.774-.8,0-1.883-29.007-.366-29.007-5.921,0-2.412,6.138-4.43,18.44-4.918V373.9h10.622v2.276a123.314,123.314,0,0,1,15.215,1.233l-5.325,3.645a102.839,102.839,0,0,0-14.619-1.111c-5.175,0-6.774.42-6.774.935,0,1.788,29.007.3,29.007,5.785C360.21,388.939,354.357,390.985,342.814,391.554Z",
    transform: "translate(80.683 97.958)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "y",
    d: "M342.534,390.97v2.357H331.966v-2.249a137.786,137.786,0,0,1-19.266-1.49l5.7-3.658a113.039,113.039,0,0,0,17.3,1.355c5.026,0,6.774-.3,6.774-.8,0-1.883-29.007-.366-29.007-5.921,0-2.412,6.151-4.43,18.439-4.918V373.33H342.48v2.263a123.073,123.073,0,0,1,15.215,1.233l-5.3,3.658a102.689,102.689,0,0,0-14.619-1.111c-5.162,0-6.774.42-6.774.935,0,1.788,29.007.3,29.007,5.785C360,388.4,354.145,390.4,342.534,390.97Z",
    transform: "translate(80.584 97.755)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ab",
    d: "M411.82,378.534v.135a8.577,8.577,0,0,1-3.292,6.205,19.056,19.056,0,0,1-1.734,1.355,35.532,35.532,0,0,1-6.585,3.617l-1.734.7c-2.005.8-4.2,1.531-6.571,2.222l-1.748.474q-3.109.833-6.571,1.545l-1.734.339c-2.113.406-4.308.759-6.585,1.084l-1.734.244c-2.141.271-4.336.515-6.585.718l-1.734.149c-2.154.176-4.349.325-6.585.42l-1.734.081c-2.154.081-4.349.122-6.571.135h-1.748c-2.222,0-4.417,0-6.571-.135l-1.734-.068c-1.653-.068-3.279-.163-4.877-.271l-1.707-.122-1.734-.149c-2.249-.2-4.444-.434-6.585-.7l-1.734-.23c-1.355-.19-2.71-.393-4-.61-.881-.135-1.734-.284-2.588-.447l-1.734-.339q-3.455-.671-6.585-1.49l-1.219-.325-.515-.149c-.935-.257-1.856-.542-2.71-.813-1.355-.434-2.628-.881-3.834-1.355l-1.734-.691a40.314,40.314,0,0,1-5.839-2.967l-.745-.488c-.3-.2-.6-.406-.867-.623s-.6-.447-.867-.677c-2.507-2.1-3.888-4.363-3.888-6.774V364.66H411.82Z",
    transform: "translate(71.29 94.679)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M291.054,364.78v21.976c-.3-.2-.6-.406-.867-.623s-.6-.447-.867-.677V364.78Z",
    transform: "translate(72.287 94.721)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M297.194,364.77v26.054l-1.734-.691V364.77Z",
    transform: "translate(74.466 94.718)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M303.324,364.76v28.777l-1.219-.325-.515-.149V364.774Z",
    transform: "translate(76.642 94.714)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M309.454,364.75V395.3l-1.734-.339v-30.2Z",
    transform: "translate(78.817 94.711)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M315.6,364.75v31.839l-1.734-.23V364.75Z",
    transform: "translate(80.999 94.711)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M321.744,364.74v32.706l-1.734-.149V364.781Z",
    transform: "translate(83.178 94.707)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M327.884,364.73v33.18l-1.734-.068V364.73Z",
    transform: "translate(85.357 94.704)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M334.028,364.724v33.316H332.28V364.71Z",
    transform: "translate(87.532 94.697)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M340.154,364.71v33.113l-1.734.081V364.71Z",
    transform: "translate(89.711 94.697)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M346.294,364.7v32.516l-1.734.149V364.7Z",
    transform: "translate(91.89 94.693)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M352.454,364.69v31.582l-1.734.244V364.69Z",
    transform: "translate(94.076 94.689)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M358.574,364.68v30.24l-1.734.339V364.68Z",
    transform: "translate(96.247 94.686)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M364.718,364.67v28.195l-1.748.474V364.684Z",
    transform: "translate(98.423 94.682)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M370.844,364.66v25.282l-1.734.7V364.674Z",
    transform: "translate(100.601 94.679)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M376.984,364.678v20.255a19.039,19.039,0,0,1-1.734,1.355V364.61Z",
    transform: "translate(102.78 94.661)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "y",
    d: "M411.821,369.436c0,9.823-28.045,17.789-62.648,17.789-4.728,0-9.335-.149-13.765-.434-5.568-.352-10.839-.921-15.757-1.667-4.363-.664-8.427-1.463-12.1-2.4-1.124-.285-2.222-.583-3.265-.881a52.844,52.844,0,0,1-11.408-4.593c-.569-.339-1.111-.677-1.612-1.016-3.048-2.1-4.742-4.4-4.742-6.774a3.569,3.569,0,0,1,0-.664c1.206-9.484,28.777-17.139,62.594-17.139a206.373,206.373,0,0,1,23.534,1.355c1.355.163,2.777.339,4.132.528a126.823,126.823,0,0,1,15.947,3.2c1.03.284,2.019.569,2.981.881a50.566,50.566,0,0,1,8.78,3.563,18.5,18.5,0,0,1,5.636,4.268,6.694,6.694,0,0,1,1.6,3.4,5.283,5.283,0,0,1,.095.583Z",
    transform: "translate(71.29 90.066)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ak",
    d: "M401.451,362.9l-74.774,21.42c-5.568-.352-10.839-.921-15.757-1.667l84.9-24.022A18.493,18.493,0,0,1,401.451,362.9Z",
    transform: "translate(79.952 92.539)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ak",
    d: "M375.553,353.138l-84,23.791c-.569-.339-1.111-.677-1.612-1.016l81.44-23.3C372.83,352.759,374.2,352.935,375.553,353.138Z",
    transform: "translate(72.507 90.403)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ak",
    d: "M391.056,356.231l-88.2,25.187c-1.125-.285-2.222-.583-3.265-.881l88.5-25.187C389.105,355.635,390.094,355.919,391.056,356.231Z",
    transform: "translate(75.932 91.375)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M395.879,368.506a5.247,5.247,0,0,1,0,.65c-1.219,7.533-23.2,13.549-50.035,13.549s-48.775-6.029-50.021-13.549a5.267,5.267,0,0,1,0-.65c0-7.845,22.464-14.226,50.13-14.226S395.879,360.675,395.879,368.506Z",
    transform: "translate(74.591 90.995)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ab",
    d: "M395.846,368.812c-1.219,7.533-23.2,13.549-50.035,13.549h-1.788a165.449,165.449,0,0,1-16.99-1.03,114.433,114.433,0,0,1-14.321-2.52q-1.6-.406-3.089-.854A35.329,35.329,0,0,1,299.15,373.3a11.418,11.418,0,0,1-1.517-1.287,5.881,5.881,0,0,1-1.843-3.211c1.206-7.547,23.182-13.548,50.021-13.548,3.4,0,6.774.095,9.931.284,1.639.095,3.252.217,4.823.352a122.047,122.047,0,0,1,17.4,2.71q1.64.393,3.17.813a42.819,42.819,0,0,1,9.687,3.848,10.663,10.663,0,0,1,4.7,4.512A4.419,4.419,0,0,1,395.846,368.812Z",
    transform: "translate(74.583 91.34)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "z",
    d: "M387.334,365.652,335.85,380.284a165.51,165.51,0,0,1-16.99-1.03l63.787-18.114A10.663,10.663,0,0,1,387.334,365.652Z",
    transform: "translate(82.77 93.43)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "z",
    d: "M360.083,355.8l-61.416,17.437a11.423,11.423,0,0,1-1.517-1.287l58.055-16.5C356.9,355.545,358.511,355.667,360.083,355.8Z",
    transform: "translate(75.066 91.411)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "z",
    d: "M377.509,358.513l-68.42,19.442q-1.6-.406-3.089-.854l68.339-19.4Q375.992,358.106,377.509,358.513Z",
    transform: "translate(78.206 92.209)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M345.664,375.354v2.371H335.1v-2.263a137.785,137.785,0,0,1-19.266-1.49l5.65-3.672a113.23,113.23,0,0,0,17.315,1.355c5.013,0,6.774-.3,6.774-.8,0-1.883-29.007-.366-29.007-5.921,0-2.412,6.151-4.43,18.44-4.918V357.7h10.568v2.276a122.828,122.828,0,0,1,15.215,1.233l-5.23,3.672a102.511,102.511,0,0,0-14.605-1.111c-5.176,0-6.774.42-6.774.935,0,1.788,29.007.3,29.007,5.785C363.128,372.779,357.289,374.785,345.664,375.354Z",
    transform: "translate(81.695 92.209)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "y",
    d: "M345.43,374.77v2.371H334.863v-2.263a137.564,137.564,0,0,1-19.252-1.49l5.69-3.658a113.223,113.223,0,0,0,17.315,1.355c5.027,0,6.774-.3,6.774-.8,0-1.883-28.994-.366-28.994-5.921,0-2.412,6.137-4.43,18.426-4.918V357.13H345.39v2.276a122.8,122.8,0,0,1,15.215,1.233l-5.311,3.645a102.835,102.835,0,0,0-14.619-1.111c-5.176,0-6.774.42-6.774.935,0,1.788,28.994.3,28.994,5.785C362.894,372.2,357.055,374.2,345.43,374.77Z",
    transform: "translate(81.617 92.007)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ab",
    d: "M411.378,362.3v.176a8.617,8.617,0,0,1-3.292,6.205,21.124,21.124,0,0,1-1.734,1.355,36.445,36.445,0,0,1-6.585,3.617c-.556.244-1.138.474-1.734.7-2.005.8-4.214,1.531-6.585,2.222-.569.163-1.138.325-1.734.474q-3.116.84-6.585,1.545l-1.734.339c-2.114.406-4.309.759-6.571,1.084l-1.748.244c-2.127.271-4.322.515-6.571.718l-1.734.149c-2.154.176-4.349.325-6.585.42l-1.734.122c-2.168.081-4.363.122-6.585.135h-1.734c-2.222,0-4.417,0-6.585-.135h-1.734c-1.639-.068-3.265-.163-4.877-.271l-1.694-.122-1.748-.149c-2.236-.2-4.444-.434-6.571-.7l-1.734-.23q-2.032-.284-4.065-.61c-.867-.135-1.721-.285-2.574-.447l-1.734-.339c-2.3-.447-4.5-.948-6.585-1.49l-1.219-.325-.515-.149c-.948-.257-1.856-.542-2.71-.813-1.355-.434-2.615-.881-3.834-1.355l-1.761-.718a41.037,41.037,0,0,1-5.839-2.967l-.732-.488c-.312-.2-.6-.406-.881-.623s-.583-.447-.867-.677c-2.507-2.1-3.875-4.363-3.875-6.774V348.55H411.283v13.887Z",
    transform: "translate(71.109 88.962)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M290.638,348.58v21.908c-.312-.2-.6-.406-.881-.623s-.583-.447-.867-.677V348.58Z",
    transform: "translate(72.135 88.973)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M296.775,348.57v26.067L295,373.946V348.57Z",
    transform: "translate(74.303 88.969)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M302.9,348.56v28.709l-1.219-.325-.515-.149V348.574Z",
    transform: "translate(76.492 88.966)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M309.044,348.56V379.1l-1.734-.339v-30.2Z",
    transform: "translate(78.671 88.966)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M315.184,348.55v31.839l-1.734-.23V348.55Z",
    transform: "translate(80.85 88.962)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M321.328,348.54v32.706l-1.748-.149V348.581Z",
    transform: "translate(83.025 88.959)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M327.454,348.53v33.153H325.72V348.53Z",
    transform: "translate(85.204 88.955)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M333.594,348.523v33.316H331.86V348.51Z",
    transform: "translate(87.383 88.948)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M339.734,348.514v33.18H338V348.5Z",
    transform: "translate(89.562 88.944)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M345.874,348.5v32.516l-1.734.149V348.5Z",
    transform: "translate(91.741 88.944)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M352.018,348.49V380.1l-1.748.244V348.49Z",
    transform: "translate(93.916 88.941)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M358.144,348.48v30.2l-1.734.339V348.48Z",
    transform: "translate(96.095 88.937)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M364.284,348.47v28.194c-.569.163-1.138.325-1.734.474V348.484Z",
    transform: "translate(98.273 88.934)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M370.454,348.46v25.282c-.556.244-1.138.474-1.734.7V348.474Z",
    transform: "translate(100.463 88.93)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M376.564,348.46v20.323a21.105,21.105,0,0,1-1.734,1.355V348.46Z",
    transform: "translate(102.631 88.93)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "y",
    d: "M411.35,353.236c0,9.823-28.045,17.789-62.648,17.789-4.728,0-9.335-.149-13.765-.434-5.568-.352-10.839-.921-15.757-1.667-4.376-.664-8.441-1.463-12.112-2.4-1.124-.285-2.208-.583-3.252-.881a52.608,52.608,0,0,1-11.408-4.593c-.569-.339-1.111-.677-1.612-1.016-3.062-2.1-4.742-4.4-4.742-6.774a5.306,5.306,0,0,1,0-.664c1.219-9.484,28.777-17.139,62.608-17.139a206.559,206.559,0,0,1,23.534,1.355q2.032.244,4.065.528a127.336,127.336,0,0,1,15.947,3.2c1.03.285,2.019.569,2.981.881a50.569,50.569,0,0,1,8.78,3.563,18.832,18.832,0,0,1,5.636,4.268,6.774,6.774,0,0,1,1.585,3.4,3.567,3.567,0,0,1,.162.583Z",
    transform: "translate(71.124 84.317)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ak",
    d: "M401.031,346.7l-74.774,21.42c-5.568-.352-10.839-.921-15.757-1.667l84.9-24.022A18.832,18.832,0,0,1,401.031,346.7Z",
    transform: "translate(79.803 86.79)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ak",
    d: "M375.133,336.928l-84,23.791c-.569-.339-1.111-.677-1.612-1.016l81.44-23.3C372.4,336.563,373.778,336.739,375.133,336.928Z",
    transform: "translate(72.358 84.651)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ak",
    d: "M390.64,340.031l-88.228,25.187c-1.125-.285-2.208-.583-3.252-.881l88.5-25.187C388.689,339.435,389.718,339.719,390.64,340.031Z",
    transform: "translate(75.779 85.627)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M395.456,352.306a5.243,5.243,0,0,1,0,.65c-1.206,7.533-23.182,13.549-50.021,13.549s-48.775-6.029-50.021-13.549a3.507,3.507,0,0,1,0-.65c0-7.845,22.463-14.226,50.13-14.226S395.456,344.461,395.456,352.306Z",
    transform: "translate(74.445 85.247)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ab",
    d: "M395.4,352.612c-1.206,7.533-23.182,13.549-50.021,13.549h-1.748a165.494,165.494,0,0,1-16.99-1.03,114.446,114.446,0,0,1-14.321-2.52q-1.612-.407-3.089-.854A35.225,35.225,0,0,1,298.76,357.1a12.551,12.551,0,0,1-1.531-1.287A5.934,5.934,0,0,1,295.4,352.6c1.206-7.547,23.182-13.549,50.021-13.549,3.387,0,6.707.095,9.931.284,1.626.095,3.238.217,4.823.352a122.33,122.33,0,0,1,17.4,2.71c1.084.257,2.141.528,3.157.813a42.817,42.817,0,0,1,9.687,3.848,10.7,10.7,0,0,1,4.715,4.512,4.388,4.388,0,0,1,.271,1.043Z",
    transform: "translate(74.445 85.591)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "z",
    d: "M386.934,349.452,335.45,364.084a165.476,165.476,0,0,1-16.99-1.03l63.773-18.114A10.7,10.7,0,0,1,386.934,349.452Z",
    transform: "translate(82.628 87.681)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "z",
    d: "M359.667,339.6l-61.415,17.437a12.547,12.547,0,0,1-1.531-1.287l58.123-16.5C356.469,339.345,358.068,339.467,359.667,339.6Z",
    transform: "translate(74.913 85.662)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "z",
    d: "M377.076,342.313l-68.407,19.442q-1.612-.406-3.089-.854l68.312-19.4C375,341.757,376.06,342.028,377.076,342.313Z",
    transform: "translate(78.057 86.46)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M345.244,359.15v2.371H334.676v-2.263a137.765,137.765,0,0,1-19.266-1.49l5.69-3.658a113.341,113.341,0,0,0,17.315,1.355c5.026,0,6.774-.3,6.774-.8,0-1.883-29.007-.366-29.007-5.921,0-2.412,6.151-4.43,18.44-4.918V341.51H345.19v2.276a123.321,123.321,0,0,1,15.215,1.233l-5.325,3.645a102.694,102.694,0,0,0-14.619-1.111c-5.162,0-6.774.42-6.774.935,0,1.788,29.007.3,29.007,5.785C362.708,356.576,356.855,358.581,345.244,359.15Z",
    transform: "translate(81.546 86.464)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "y",
    d: "M345.014,358.649v2.371H334.446v-2.371a137.756,137.756,0,0,1-19.266-1.49l5.7-3.658a113.227,113.227,0,0,0,17.315,1.355c5.013,0,6.774-.3,6.774-.8,0-1.883-29.007-.366-29.007-5.921,0-2.412,6.151-4.43,18.44-4.918V340.9h10.568v2.276a123.015,123.015,0,0,1,15.215,1.233l-5.325,3.645a102.5,102.5,0,0,0-14.605-1.111c-5.176,0-6.774.42-6.774.935,0,1.789,29.007.3,29.007,5.785C362.478,356.007,356.639,358.012,345.014,358.649Z",
    transform: "translate(81.464 86.247)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndicateImg);
export default __webpack_public_path__ + "static/media/indicateImg.0f05ed96bae39b33ebc86a3a27e9b194.svg";
export { ForwardRef as ReactComponent };